/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
var jspb = require('google-protobuf');

var goog = jspb;
var global = Function('return this')();
goog.exportSymbol('proto.bcsdk.BcBlock', null, global);
goog.exportSymbol('proto.bcsdk.Block', null, global);
goog.exportSymbol('proto.bcsdk.BlockchainHeader', null, global);
goog.exportSymbol('proto.bcsdk.BlockchainHeaders', null, global);
goog.exportSymbol('proto.bcsdk.HistoricalOrder', null, global);
goog.exportSymbol('proto.bcsdk.MarkedTransaction', null, global);
goog.exportSymbol('proto.bcsdk.MatchedOrder', null, global);
goog.exportSymbol('proto.bcsdk.MatchedTx', null, global);
goog.exportSymbol('proto.bcsdk.MatchedTxs', null, global);
goog.exportSymbol('proto.bcsdk.Null', null, global);
goog.exportSymbol('proto.bcsdk.OpenOrder', null, global);
goog.exportSymbol('proto.bcsdk.OutPoint', null, global);
goog.exportSymbol('proto.bcsdk.Transaction', null, global);
goog.exportSymbol('proto.bcsdk.TransactionInput', null, global);
goog.exportSymbol('proto.bcsdk.TransactionOutput', null, global);
goog.exportSymbol('proto.bcsdk.UnspentTransactions', null, global);
goog.exportSymbol('proto.bcsdk.Utxo', null, global);
goog.exportSymbol('proto.bcsdk.WalletData', null, global);
goog.exportSymbol('proto.bcsdk.WalletOutPoint', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */

proto.bcsdk.Null = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.Null, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.Null.displayName = 'proto.bcsdk.Null';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.Null.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.Null.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.Null} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.Null.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.Null}
 */


proto.bcsdk.Null.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.Null();
  return proto.bcsdk.Null.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.Null} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.Null}
 */


proto.bcsdk.Null.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.Null.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.Null.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.Null} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.Null.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.Block = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.bcsdk.Block.repeatedFields_, null);
};

goog.inherits(proto.bcsdk.Block, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.Block.displayName = 'proto.bcsdk.Block';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.bcsdk.Block.repeatedFields_ = [8];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.Block.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.Block.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.Block} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.Block.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      blockchain: jspb.Message.getFieldWithDefault(msg, 1, ""),
      hash: jspb.Message.getFieldWithDefault(msg, 2, ""),
      previousHash: jspb.Message.getFieldWithDefault(msg, 3, ""),
      timestamp: jspb.Message.getFieldWithDefault(msg, 4, 0),
      height: jspb.Message.getFieldWithDefault(msg, 5, 0),
      merkleRoot: jspb.Message.getFieldWithDefault(msg, 6, ""),
      markedTxCount: jspb.Message.getFieldWithDefault(msg, 7, 0),
      markedTxsList: jspb.Message.toObjectList(msg.getMarkedTxsList(), proto.bcsdk.MarkedTransaction.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.Block}
 */


proto.bcsdk.Block.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.Block();
  return proto.bcsdk.Block.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.Block} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.Block}
 */


proto.bcsdk.Block.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setBlockchain(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setHash(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPreviousHash(value);
        break;

      case 4:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setTimestamp(value);
        break;

      case 5:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setHeight(value);
        break;

      case 6:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setMerkleRoot(value);
        break;

      case 7:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setMarkedTxCount(value);
        break;

      case 8:
        var value = new proto.bcsdk.MarkedTransaction();
        reader.readMessage(value, proto.bcsdk.MarkedTransaction.deserializeBinaryFromReader);
        msg.addMarkedTxs(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.Block.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.Block.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.Block} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.Block.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getBlockchain();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getHash();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getPreviousHash();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getTimestamp();

  if (f !== 0) {
    writer.writeUint64(4, f);
  }

  f = message.getHeight();

  if (f !== 0) {
    writer.writeUint64(5, f);
  }

  f = message.getMerkleRoot();

  if (f.length > 0) {
    writer.writeString(6, f);
  }

  f = message.getMarkedTxCount();

  if (f !== 0) {
    writer.writeUint64(7, f);
  }

  f = message.getMarkedTxsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(8, f, proto.bcsdk.MarkedTransaction.serializeBinaryToWriter);
  }
};
/**
 * optional string blockchain = 1;
 * @return {string}
 */


proto.bcsdk.Block.prototype.getBlockchain = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.Block.prototype.setBlockchain = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string hash = 2;
 * @return {string}
 */


proto.bcsdk.Block.prototype.getHash = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.bcsdk.Block.prototype.setHash = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string previous_hash = 3;
 * @return {string}
 */


proto.bcsdk.Block.prototype.getPreviousHash = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.bcsdk.Block.prototype.setPreviousHash = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional uint64 timestamp = 4;
 * @return {number}
 */


proto.bcsdk.Block.prototype.getTimestamp = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 4, 0)
  );
};
/** @param {number} value */


proto.bcsdk.Block.prototype.setTimestamp = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};
/**
 * optional uint64 height = 5;
 * @return {number}
 */


proto.bcsdk.Block.prototype.getHeight = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 5, 0)
  );
};
/** @param {number} value */


proto.bcsdk.Block.prototype.setHeight = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};
/**
 * optional string merkle_root = 6;
 * @return {string}
 */


proto.bcsdk.Block.prototype.getMerkleRoot = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 6, "")
  );
};
/** @param {string} value */


proto.bcsdk.Block.prototype.setMerkleRoot = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};
/**
 * optional uint64 marked_tx_count = 7;
 * @return {number}
 */


proto.bcsdk.Block.prototype.getMarkedTxCount = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 7, 0)
  );
};
/** @param {number} value */


proto.bcsdk.Block.prototype.setMarkedTxCount = function (value) {
  jspb.Message.setProto3IntField(this, 7, value);
};
/**
 * repeated MarkedTransaction marked_txs = 8;
 * @return {!Array<!proto.bcsdk.MarkedTransaction>}
 */


proto.bcsdk.Block.prototype.getMarkedTxsList = function () {
  return (
    /** @type{!Array<!proto.bcsdk.MarkedTransaction>} */
    jspb.Message.getRepeatedWrapperField(this, proto.bcsdk.MarkedTransaction, 8)
  );
};
/** @param {!Array<!proto.bcsdk.MarkedTransaction>} value */


proto.bcsdk.Block.prototype.setMarkedTxsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 8, value);
};
/**
 * @param {!proto.bcsdk.MarkedTransaction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.bcsdk.MarkedTransaction}
 */


proto.bcsdk.Block.prototype.addMarkedTxs = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.bcsdk.MarkedTransaction, opt_index);
};

proto.bcsdk.Block.prototype.clearMarkedTxsList = function () {
  this.setMarkedTxsList([]);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.MarkedTransaction = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.MarkedTransaction, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.MarkedTransaction.displayName = 'proto.bcsdk.MarkedTransaction';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.MarkedTransaction.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.MarkedTransaction.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.MarkedTransaction} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.MarkedTransaction.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      value: msg.getValue_asB64(),
      hash: jspb.Message.getFieldWithDefault(msg, 2, ""),
      id: jspb.Message.getFieldWithDefault(msg, 3, ""),
      token: jspb.Message.getFieldWithDefault(msg, 4, ""),
      addrFrom: jspb.Message.getFieldWithDefault(msg, 5, ""),
      addrTo: jspb.Message.getFieldWithDefault(msg, 6, ""),
      blockHeight: jspb.Message.getFieldWithDefault(msg, 7, 0),
      index: jspb.Message.getFieldWithDefault(msg, 8, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.MarkedTransaction}
 */


proto.bcsdk.MarkedTransaction.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.MarkedTransaction();
  return proto.bcsdk.MarkedTransaction.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.MarkedTransaction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.MarkedTransaction}
 */


proto.bcsdk.MarkedTransaction.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {!Uint8Array} */
        reader.readBytes();
        msg.setValue(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setHash(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setId(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setToken(value);
        break;

      case 5:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setAddrFrom(value);
        break;

      case 6:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setAddrTo(value);
        break;

      case 7:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setBlockHeight(value);
        break;

      case 8:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setIndex(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.MarkedTransaction.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.MarkedTransaction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.MarkedTransaction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.MarkedTransaction.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getValue_asU8();

  if (f.length > 0) {
    writer.writeBytes(1, f);
  }

  f = message.getHash();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getId();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getToken();

  if (f.length > 0) {
    writer.writeString(4, f);
  }

  f = message.getAddrFrom();

  if (f.length > 0) {
    writer.writeString(5, f);
  }

  f = message.getAddrTo();

  if (f.length > 0) {
    writer.writeString(6, f);
  }

  f = message.getBlockHeight();

  if (f !== 0) {
    writer.writeUint64(7, f);
  }

  f = message.getIndex();

  if (f !== 0) {
    writer.writeUint64(8, f);
  }
};
/**
 * optional bytes value = 1;
 * @return {!(string|Uint8Array)}
 */


proto.bcsdk.MarkedTransaction.prototype.getValue = function () {
  return (
    /** @type {!(string|Uint8Array)} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * optional bytes value = 1;
 * This is a type-conversion wrapper around `getValue()`
 * @return {string}
 */


proto.bcsdk.MarkedTransaction.prototype.getValue_asB64 = function () {
  return (
    /** @type {string} */
    jspb.Message.bytesAsB64(this.getValue())
  );
};
/**
 * optional bytes value = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getValue()`
 * @return {!Uint8Array}
 */


proto.bcsdk.MarkedTransaction.prototype.getValue_asU8 = function () {
  return (
    /** @type {!Uint8Array} */
    jspb.Message.bytesAsU8(this.getValue())
  );
};
/** @param {!(string|Uint8Array)} value */


proto.bcsdk.MarkedTransaction.prototype.setValue = function (value) {
  jspb.Message.setProto3BytesField(this, 1, value);
};
/**
 * optional string hash = 2;
 * @return {string}
 */


proto.bcsdk.MarkedTransaction.prototype.getHash = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.bcsdk.MarkedTransaction.prototype.setHash = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string id = 3;
 * @return {string}
 */


proto.bcsdk.MarkedTransaction.prototype.getId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.bcsdk.MarkedTransaction.prototype.setId = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string token = 4;
 * @return {string}
 */


proto.bcsdk.MarkedTransaction.prototype.getToken = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/** @param {string} value */


proto.bcsdk.MarkedTransaction.prototype.setToken = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string addr_from = 5;
 * @return {string}
 */


proto.bcsdk.MarkedTransaction.prototype.getAddrFrom = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 5, "")
  );
};
/** @param {string} value */


proto.bcsdk.MarkedTransaction.prototype.setAddrFrom = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string addr_to = 6;
 * @return {string}
 */


proto.bcsdk.MarkedTransaction.prototype.getAddrTo = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 6, "")
  );
};
/** @param {string} value */


proto.bcsdk.MarkedTransaction.prototype.setAddrTo = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};
/**
 * optional uint64 block_height = 7;
 * @return {number}
 */


proto.bcsdk.MarkedTransaction.prototype.getBlockHeight = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 7, 0)
  );
};
/** @param {number} value */


proto.bcsdk.MarkedTransaction.prototype.setBlockHeight = function (value) {
  jspb.Message.setProto3IntField(this, 7, value);
};
/**
 * optional uint64 index = 8;
 * @return {number}
 */


proto.bcsdk.MarkedTransaction.prototype.getIndex = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 8, 0)
  );
};
/** @param {number} value */


proto.bcsdk.MarkedTransaction.prototype.setIndex = function (value) {
  jspb.Message.setProto3IntField(this, 8, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.BlockchainHeaders = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.bcsdk.BlockchainHeaders.repeatedFields_, null);
};

goog.inherits(proto.bcsdk.BlockchainHeaders, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.BlockchainHeaders.displayName = 'proto.bcsdk.BlockchainHeaders';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.bcsdk.BlockchainHeaders.repeatedFields_ = [1, 2, 3, 4, 5];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.BlockchainHeaders.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.BlockchainHeaders.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.BlockchainHeaders} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.BlockchainHeaders.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      btcList: jspb.Message.toObjectList(msg.getBtcList(), proto.bcsdk.BlockchainHeader.toObject, includeInstance),
      ethList: jspb.Message.toObjectList(msg.getEthList(), proto.bcsdk.BlockchainHeader.toObject, includeInstance),
      lskList: jspb.Message.toObjectList(msg.getLskList(), proto.bcsdk.BlockchainHeader.toObject, includeInstance),
      neoList: jspb.Message.toObjectList(msg.getNeoList(), proto.bcsdk.BlockchainHeader.toObject, includeInstance),
      wavList: jspb.Message.toObjectList(msg.getWavList(), proto.bcsdk.BlockchainHeader.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.BlockchainHeaders}
 */


proto.bcsdk.BlockchainHeaders.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.BlockchainHeaders();
  return proto.bcsdk.BlockchainHeaders.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.BlockchainHeaders} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.BlockchainHeaders}
 */


proto.bcsdk.BlockchainHeaders.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.bcsdk.BlockchainHeader();
        reader.readMessage(value, proto.bcsdk.BlockchainHeader.deserializeBinaryFromReader);
        msg.addBtc(value);
        break;

      case 2:
        var value = new proto.bcsdk.BlockchainHeader();
        reader.readMessage(value, proto.bcsdk.BlockchainHeader.deserializeBinaryFromReader);
        msg.addEth(value);
        break;

      case 3:
        var value = new proto.bcsdk.BlockchainHeader();
        reader.readMessage(value, proto.bcsdk.BlockchainHeader.deserializeBinaryFromReader);
        msg.addLsk(value);
        break;

      case 4:
        var value = new proto.bcsdk.BlockchainHeader();
        reader.readMessage(value, proto.bcsdk.BlockchainHeader.deserializeBinaryFromReader);
        msg.addNeo(value);
        break;

      case 5:
        var value = new proto.bcsdk.BlockchainHeader();
        reader.readMessage(value, proto.bcsdk.BlockchainHeader.deserializeBinaryFromReader);
        msg.addWav(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.BlockchainHeaders.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.BlockchainHeaders.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.BlockchainHeaders} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.BlockchainHeaders.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getBtcList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.bcsdk.BlockchainHeader.serializeBinaryToWriter);
  }

  f = message.getEthList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(2, f, proto.bcsdk.BlockchainHeader.serializeBinaryToWriter);
  }

  f = message.getLskList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(3, f, proto.bcsdk.BlockchainHeader.serializeBinaryToWriter);
  }

  f = message.getNeoList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(4, f, proto.bcsdk.BlockchainHeader.serializeBinaryToWriter);
  }

  f = message.getWavList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(5, f, proto.bcsdk.BlockchainHeader.serializeBinaryToWriter);
  }
};
/**
 * repeated BlockchainHeader btc = 1;
 * @return {!Array<!proto.bcsdk.BlockchainHeader>}
 */


proto.bcsdk.BlockchainHeaders.prototype.getBtcList = function () {
  return (
    /** @type{!Array<!proto.bcsdk.BlockchainHeader>} */
    jspb.Message.getRepeatedWrapperField(this, proto.bcsdk.BlockchainHeader, 1)
  );
};
/** @param {!Array<!proto.bcsdk.BlockchainHeader>} value */


proto.bcsdk.BlockchainHeaders.prototype.setBtcList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.bcsdk.BlockchainHeader=} opt_value
 * @param {number=} opt_index
 * @return {!proto.bcsdk.BlockchainHeader}
 */


proto.bcsdk.BlockchainHeaders.prototype.addBtc = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.bcsdk.BlockchainHeader, opt_index);
};

proto.bcsdk.BlockchainHeaders.prototype.clearBtcList = function () {
  this.setBtcList([]);
};
/**
 * repeated BlockchainHeader eth = 2;
 * @return {!Array<!proto.bcsdk.BlockchainHeader>}
 */


proto.bcsdk.BlockchainHeaders.prototype.getEthList = function () {
  return (
    /** @type{!Array<!proto.bcsdk.BlockchainHeader>} */
    jspb.Message.getRepeatedWrapperField(this, proto.bcsdk.BlockchainHeader, 2)
  );
};
/** @param {!Array<!proto.bcsdk.BlockchainHeader>} value */


proto.bcsdk.BlockchainHeaders.prototype.setEthList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.bcsdk.BlockchainHeader=} opt_value
 * @param {number=} opt_index
 * @return {!proto.bcsdk.BlockchainHeader}
 */


proto.bcsdk.BlockchainHeaders.prototype.addEth = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.bcsdk.BlockchainHeader, opt_index);
};

proto.bcsdk.BlockchainHeaders.prototype.clearEthList = function () {
  this.setEthList([]);
};
/**
 * repeated BlockchainHeader lsk = 3;
 * @return {!Array<!proto.bcsdk.BlockchainHeader>}
 */


proto.bcsdk.BlockchainHeaders.prototype.getLskList = function () {
  return (
    /** @type{!Array<!proto.bcsdk.BlockchainHeader>} */
    jspb.Message.getRepeatedWrapperField(this, proto.bcsdk.BlockchainHeader, 3)
  );
};
/** @param {!Array<!proto.bcsdk.BlockchainHeader>} value */


proto.bcsdk.BlockchainHeaders.prototype.setLskList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};
/**
 * @param {!proto.bcsdk.BlockchainHeader=} opt_value
 * @param {number=} opt_index
 * @return {!proto.bcsdk.BlockchainHeader}
 */


proto.bcsdk.BlockchainHeaders.prototype.addLsk = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.bcsdk.BlockchainHeader, opt_index);
};

proto.bcsdk.BlockchainHeaders.prototype.clearLskList = function () {
  this.setLskList([]);
};
/**
 * repeated BlockchainHeader neo = 4;
 * @return {!Array<!proto.bcsdk.BlockchainHeader>}
 */


proto.bcsdk.BlockchainHeaders.prototype.getNeoList = function () {
  return (
    /** @type{!Array<!proto.bcsdk.BlockchainHeader>} */
    jspb.Message.getRepeatedWrapperField(this, proto.bcsdk.BlockchainHeader, 4)
  );
};
/** @param {!Array<!proto.bcsdk.BlockchainHeader>} value */


proto.bcsdk.BlockchainHeaders.prototype.setNeoList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 4, value);
};
/**
 * @param {!proto.bcsdk.BlockchainHeader=} opt_value
 * @param {number=} opt_index
 * @return {!proto.bcsdk.BlockchainHeader}
 */


proto.bcsdk.BlockchainHeaders.prototype.addNeo = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.bcsdk.BlockchainHeader, opt_index);
};

proto.bcsdk.BlockchainHeaders.prototype.clearNeoList = function () {
  this.setNeoList([]);
};
/**
 * repeated BlockchainHeader wav = 5;
 * @return {!Array<!proto.bcsdk.BlockchainHeader>}
 */


proto.bcsdk.BlockchainHeaders.prototype.getWavList = function () {
  return (
    /** @type{!Array<!proto.bcsdk.BlockchainHeader>} */
    jspb.Message.getRepeatedWrapperField(this, proto.bcsdk.BlockchainHeader, 5)
  );
};
/** @param {!Array<!proto.bcsdk.BlockchainHeader>} value */


proto.bcsdk.BlockchainHeaders.prototype.setWavList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 5, value);
};
/**
 * @param {!proto.bcsdk.BlockchainHeader=} opt_value
 * @param {number=} opt_index
 * @return {!proto.bcsdk.BlockchainHeader}
 */


proto.bcsdk.BlockchainHeaders.prototype.addWav = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.bcsdk.BlockchainHeader, opt_index);
};

proto.bcsdk.BlockchainHeaders.prototype.clearWavList = function () {
  this.setWavList([]);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.BcBlock = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.bcsdk.BcBlock.repeatedFields_, null);
};

goog.inherits(proto.bcsdk.BcBlock, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.BcBlock.displayName = 'proto.bcsdk.BcBlock';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.bcsdk.BcBlock.repeatedFields_ = [20, 26];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.BcBlock.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.BcBlock.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.BcBlock} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.BcBlock.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      hash: jspb.Message.getFieldWithDefault(msg, 1, ""),
      previousHash: jspb.Message.getFieldWithDefault(msg, 2, ""),
      version: jspb.Message.getFieldWithDefault(msg, 3, 0),
      schemaVersion: jspb.Message.getFieldWithDefault(msg, 4, 0),
      height: jspb.Message.getFieldWithDefault(msg, 5, 0),
      miner: jspb.Message.getFieldWithDefault(msg, 6, ""),
      difficulty: jspb.Message.getFieldWithDefault(msg, 7, ""),
      timestamp: jspb.Message.getFieldWithDefault(msg, 8, 0),
      merkleRoot: jspb.Message.getFieldWithDefault(msg, 9, ""),
      chainRoot: jspb.Message.getFieldWithDefault(msg, 10, ""),
      distance: jspb.Message.getFieldWithDefault(msg, 11, ""),
      totalDistance: jspb.Message.getFieldWithDefault(msg, 12, ""),
      nonce: jspb.Message.getFieldWithDefault(msg, 13, ""),
      nrgGrant: jspb.Message.getFieldWithDefault(msg, 14, 0),
      targetHash: jspb.Message.getFieldWithDefault(msg, 15, ""),
      targetHeight: jspb.Message.getFieldWithDefault(msg, 16, 0),
      targetMiner: jspb.Message.getFieldWithDefault(msg, 17, ""),
      targetSignature: jspb.Message.getFieldWithDefault(msg, 18, ""),
      twn: jspb.Message.getFieldWithDefault(msg, 19, 0),
      twsList: jspb.Message.getRepeatedField(msg, 20),
      emblemWeight: jspb.Message.getFieldWithDefault(msg, 21, 0),
      emblemChainBlockHash: jspb.Message.getFieldWithDefault(msg, 22, ""),
      emblemChainFingerprintRoot: jspb.Message.getFieldWithDefault(msg, 23, ""),
      emblemChainAddress: jspb.Message.getFieldWithDefault(msg, 24, ""),
      txCount: jspb.Message.getFieldWithDefault(msg, 25, 0),
      txsList: jspb.Message.toObjectList(msg.getTxsList(), proto.bcsdk.Transaction.toObject, includeInstance),
      txFeeBase: jspb.Message.getFieldWithDefault(msg, 27, 0),
      txDistanceSumLimit: jspb.Message.getFieldWithDefault(msg, 28, 0),
      blockchainHeadersCount: jspb.Message.getFieldWithDefault(msg, 29, 0),
      blockchainHeaders: (f = msg.getBlockchainHeaders()) && proto.bcsdk.BlockchainHeaders.toObject(includeInstance, f),
      blockchainFingerprintsRoot: jspb.Message.getFieldWithDefault(msg, 31, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.BcBlock}
 */


proto.bcsdk.BcBlock.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.BcBlock();
  return proto.bcsdk.BcBlock.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.BcBlock} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.BcBlock}
 */


proto.bcsdk.BcBlock.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setHash(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPreviousHash(value);
        break;

      case 3:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setVersion(value);
        break;

      case 4:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setSchemaVersion(value);
        break;

      case 5:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setHeight(value);
        break;

      case 6:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setMiner(value);
        break;

      case 7:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setDifficulty(value);
        break;

      case 8:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setTimestamp(value);
        break;

      case 9:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setMerkleRoot(value);
        break;

      case 10:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setChainRoot(value);
        break;

      case 11:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setDistance(value);
        break;

      case 12:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setTotalDistance(value);
        break;

      case 13:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setNonce(value);
        break;

      case 14:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setNrgGrant(value);
        break;

      case 15:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setTargetHash(value);
        break;

      case 16:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setTargetHeight(value);
        break;

      case 17:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setTargetMiner(value);
        break;

      case 18:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setTargetSignature(value);
        break;

      case 19:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setTwn(value);
        break;

      case 20:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addTws(value);
        break;

      case 21:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setEmblemWeight(value);
        break;

      case 22:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setEmblemChainBlockHash(value);
        break;

      case 23:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setEmblemChainFingerprintRoot(value);
        break;

      case 24:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setEmblemChainAddress(value);
        break;

      case 25:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setTxCount(value);
        break;

      case 26:
        var value = new proto.bcsdk.Transaction();
        reader.readMessage(value, proto.bcsdk.Transaction.deserializeBinaryFromReader);
        msg.addTxs(value);
        break;

      case 27:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setTxFeeBase(value);
        break;

      case 28:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setTxDistanceSumLimit(value);
        break;

      case 29:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setBlockchainHeadersCount(value);
        break;

      case 30:
        var value = new proto.bcsdk.BlockchainHeaders();
        reader.readMessage(value, proto.bcsdk.BlockchainHeaders.deserializeBinaryFromReader);
        msg.setBlockchainHeaders(value);
        break;

      case 31:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setBlockchainFingerprintsRoot(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.BcBlock.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.BcBlock.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.BcBlock} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.BcBlock.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getHash();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getPreviousHash();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getVersion();

  if (f !== 0) {
    writer.writeUint64(3, f);
  }

  f = message.getSchemaVersion();

  if (f !== 0) {
    writer.writeUint64(4, f);
  }

  f = message.getHeight();

  if (f !== 0) {
    writer.writeUint64(5, f);
  }

  f = message.getMiner();

  if (f.length > 0) {
    writer.writeString(6, f);
  }

  f = message.getDifficulty();

  if (f.length > 0) {
    writer.writeString(7, f);
  }

  f = message.getTimestamp();

  if (f !== 0) {
    writer.writeUint64(8, f);
  }

  f = message.getMerkleRoot();

  if (f.length > 0) {
    writer.writeString(9, f);
  }

  f = message.getChainRoot();

  if (f.length > 0) {
    writer.writeString(10, f);
  }

  f = message.getDistance();

  if (f.length > 0) {
    writer.writeString(11, f);
  }

  f = message.getTotalDistance();

  if (f.length > 0) {
    writer.writeString(12, f);
  }

  f = message.getNonce();

  if (f.length > 0) {
    writer.writeString(13, f);
  }

  f = message.getNrgGrant();

  if (f !== 0) {
    writer.writeUint64(14, f);
  }

  f = message.getTargetHash();

  if (f.length > 0) {
    writer.writeString(15, f);
  }

  f = message.getTargetHeight();

  if (f !== 0) {
    writer.writeUint64(16, f);
  }

  f = message.getTargetMiner();

  if (f.length > 0) {
    writer.writeString(17, f);
  }

  f = message.getTargetSignature();

  if (f.length > 0) {
    writer.writeString(18, f);
  }

  f = message.getTwn();

  if (f !== 0) {
    writer.writeUint64(19, f);
  }

  f = message.getTwsList();

  if (f.length > 0) {
    writer.writeRepeatedString(20, f);
  }

  f = message.getEmblemWeight();

  if (f !== 0) {
    writer.writeUint64(21, f);
  }

  f = message.getEmblemChainBlockHash();

  if (f.length > 0) {
    writer.writeString(22, f);
  }

  f = message.getEmblemChainFingerprintRoot();

  if (f.length > 0) {
    writer.writeString(23, f);
  }

  f = message.getEmblemChainAddress();

  if (f.length > 0) {
    writer.writeString(24, f);
  }

  f = message.getTxCount();

  if (f !== 0) {
    writer.writeUint64(25, f);
  }

  f = message.getTxsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(26, f, proto.bcsdk.Transaction.serializeBinaryToWriter);
  }

  f = message.getTxFeeBase();

  if (f !== 0) {
    writer.writeUint64(27, f);
  }

  f = message.getTxDistanceSumLimit();

  if (f !== 0) {
    writer.writeUint64(28, f);
  }

  f = message.getBlockchainHeadersCount();

  if (f !== 0) {
    writer.writeUint64(29, f);
  }

  f = message.getBlockchainHeaders();

  if (f != null) {
    writer.writeMessage(30, f, proto.bcsdk.BlockchainHeaders.serializeBinaryToWriter);
  }

  f = message.getBlockchainFingerprintsRoot();

  if (f.length > 0) {
    writer.writeString(31, f);
  }
};
/**
 * optional string hash = 1;
 * @return {string}
 */


proto.bcsdk.BcBlock.prototype.getHash = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.BcBlock.prototype.setHash = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string previous_hash = 2;
 * @return {string}
 */


proto.bcsdk.BcBlock.prototype.getPreviousHash = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.bcsdk.BcBlock.prototype.setPreviousHash = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional uint64 version = 3;
 * @return {number}
 */


proto.bcsdk.BcBlock.prototype.getVersion = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {number} value */


proto.bcsdk.BcBlock.prototype.setVersion = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};
/**
 * optional uint64 schema_version = 4;
 * @return {number}
 */


proto.bcsdk.BcBlock.prototype.getSchemaVersion = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 4, 0)
  );
};
/** @param {number} value */


proto.bcsdk.BcBlock.prototype.setSchemaVersion = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};
/**
 * optional uint64 height = 5;
 * @return {number}
 */


proto.bcsdk.BcBlock.prototype.getHeight = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 5, 0)
  );
};
/** @param {number} value */


proto.bcsdk.BcBlock.prototype.setHeight = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};
/**
 * optional string miner = 6;
 * @return {string}
 */


proto.bcsdk.BcBlock.prototype.getMiner = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 6, "")
  );
};
/** @param {string} value */


proto.bcsdk.BcBlock.prototype.setMiner = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string difficulty = 7;
 * @return {string}
 */


proto.bcsdk.BcBlock.prototype.getDifficulty = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 7, "")
  );
};
/** @param {string} value */


proto.bcsdk.BcBlock.prototype.setDifficulty = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};
/**
 * optional uint64 timestamp = 8;
 * @return {number}
 */


proto.bcsdk.BcBlock.prototype.getTimestamp = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 8, 0)
  );
};
/** @param {number} value */


proto.bcsdk.BcBlock.prototype.setTimestamp = function (value) {
  jspb.Message.setProto3IntField(this, 8, value);
};
/**
 * optional string merkle_root = 9;
 * @return {string}
 */


proto.bcsdk.BcBlock.prototype.getMerkleRoot = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 9, "")
  );
};
/** @param {string} value */


proto.bcsdk.BcBlock.prototype.setMerkleRoot = function (value) {
  jspb.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string chain_root = 10;
 * @return {string}
 */


proto.bcsdk.BcBlock.prototype.getChainRoot = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 10, "")
  );
};
/** @param {string} value */


proto.bcsdk.BcBlock.prototype.setChainRoot = function (value) {
  jspb.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string distance = 11;
 * @return {string}
 */


proto.bcsdk.BcBlock.prototype.getDistance = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 11, "")
  );
};
/** @param {string} value */


proto.bcsdk.BcBlock.prototype.setDistance = function (value) {
  jspb.Message.setProto3StringField(this, 11, value);
};
/**
 * optional string total_distance = 12;
 * @return {string}
 */


proto.bcsdk.BcBlock.prototype.getTotalDistance = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 12, "")
  );
};
/** @param {string} value */


proto.bcsdk.BcBlock.prototype.setTotalDistance = function (value) {
  jspb.Message.setProto3StringField(this, 12, value);
};
/**
 * optional string nonce = 13;
 * @return {string}
 */


proto.bcsdk.BcBlock.prototype.getNonce = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 13, "")
  );
};
/** @param {string} value */


proto.bcsdk.BcBlock.prototype.setNonce = function (value) {
  jspb.Message.setProto3StringField(this, 13, value);
};
/**
 * optional uint64 nrg_grant = 14;
 * @return {number}
 */


proto.bcsdk.BcBlock.prototype.getNrgGrant = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 14, 0)
  );
};
/** @param {number} value */


proto.bcsdk.BcBlock.prototype.setNrgGrant = function (value) {
  jspb.Message.setProto3IntField(this, 14, value);
};
/**
 * optional string target_hash = 15;
 * @return {string}
 */


proto.bcsdk.BcBlock.prototype.getTargetHash = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 15, "")
  );
};
/** @param {string} value */


proto.bcsdk.BcBlock.prototype.setTargetHash = function (value) {
  jspb.Message.setProto3StringField(this, 15, value);
};
/**
 * optional uint64 target_height = 16;
 * @return {number}
 */


proto.bcsdk.BcBlock.prototype.getTargetHeight = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 16, 0)
  );
};
/** @param {number} value */


proto.bcsdk.BcBlock.prototype.setTargetHeight = function (value) {
  jspb.Message.setProto3IntField(this, 16, value);
};
/**
 * optional string target_miner = 17;
 * @return {string}
 */


proto.bcsdk.BcBlock.prototype.getTargetMiner = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 17, "")
  );
};
/** @param {string} value */


proto.bcsdk.BcBlock.prototype.setTargetMiner = function (value) {
  jspb.Message.setProto3StringField(this, 17, value);
};
/**
 * optional string target_signature = 18;
 * @return {string}
 */


proto.bcsdk.BcBlock.prototype.getTargetSignature = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 18, "")
  );
};
/** @param {string} value */


proto.bcsdk.BcBlock.prototype.setTargetSignature = function (value) {
  jspb.Message.setProto3StringField(this, 18, value);
};
/**
 * optional uint64 twn = 19;
 * @return {number}
 */


proto.bcsdk.BcBlock.prototype.getTwn = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 19, 0)
  );
};
/** @param {number} value */


proto.bcsdk.BcBlock.prototype.setTwn = function (value) {
  jspb.Message.setProto3IntField(this, 19, value);
};
/**
 * repeated string tws = 20;
 * @return {!Array<string>}
 */


proto.bcsdk.BcBlock.prototype.getTwsList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 20)
  );
};
/** @param {!Array<string>} value */


proto.bcsdk.BcBlock.prototype.setTwsList = function (value) {
  jspb.Message.setField(this, 20, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.bcsdk.BcBlock.prototype.addTws = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 20, value, opt_index);
};

proto.bcsdk.BcBlock.prototype.clearTwsList = function () {
  this.setTwsList([]);
};
/**
 * optional uint64 emblem_weight = 21;
 * @return {number}
 */


proto.bcsdk.BcBlock.prototype.getEmblemWeight = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 21, 0)
  );
};
/** @param {number} value */


proto.bcsdk.BcBlock.prototype.setEmblemWeight = function (value) {
  jspb.Message.setProto3IntField(this, 21, value);
};
/**
 * optional string emblem_chain_block_hash = 22;
 * @return {string}
 */


proto.bcsdk.BcBlock.prototype.getEmblemChainBlockHash = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 22, "")
  );
};
/** @param {string} value */


proto.bcsdk.BcBlock.prototype.setEmblemChainBlockHash = function (value) {
  jspb.Message.setProto3StringField(this, 22, value);
};
/**
 * optional string emblem_chain_fingerprint_root = 23;
 * @return {string}
 */


proto.bcsdk.BcBlock.prototype.getEmblemChainFingerprintRoot = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 23, "")
  );
};
/** @param {string} value */


proto.bcsdk.BcBlock.prototype.setEmblemChainFingerprintRoot = function (value) {
  jspb.Message.setProto3StringField(this, 23, value);
};
/**
 * optional string emblem_chain_address = 24;
 * @return {string}
 */


proto.bcsdk.BcBlock.prototype.getEmblemChainAddress = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 24, "")
  );
};
/** @param {string} value */


proto.bcsdk.BcBlock.prototype.setEmblemChainAddress = function (value) {
  jspb.Message.setProto3StringField(this, 24, value);
};
/**
 * optional uint64 tx_count = 25;
 * @return {number}
 */


proto.bcsdk.BcBlock.prototype.getTxCount = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 25, 0)
  );
};
/** @param {number} value */


proto.bcsdk.BcBlock.prototype.setTxCount = function (value) {
  jspb.Message.setProto3IntField(this, 25, value);
};
/**
 * repeated Transaction txs = 26;
 * @return {!Array<!proto.bcsdk.Transaction>}
 */


proto.bcsdk.BcBlock.prototype.getTxsList = function () {
  return (
    /** @type{!Array<!proto.bcsdk.Transaction>} */
    jspb.Message.getRepeatedWrapperField(this, proto.bcsdk.Transaction, 26)
  );
};
/** @param {!Array<!proto.bcsdk.Transaction>} value */


proto.bcsdk.BcBlock.prototype.setTxsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 26, value);
};
/**
 * @param {!proto.bcsdk.Transaction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.bcsdk.Transaction}
 */


proto.bcsdk.BcBlock.prototype.addTxs = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 26, opt_value, proto.bcsdk.Transaction, opt_index);
};

proto.bcsdk.BcBlock.prototype.clearTxsList = function () {
  this.setTxsList([]);
};
/**
 * optional uint64 tx_fee_base = 27;
 * @return {number}
 */


proto.bcsdk.BcBlock.prototype.getTxFeeBase = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 27, 0)
  );
};
/** @param {number} value */


proto.bcsdk.BcBlock.prototype.setTxFeeBase = function (value) {
  jspb.Message.setProto3IntField(this, 27, value);
};
/**
 * optional uint64 tx_distance_sum_limit = 28;
 * @return {number}
 */


proto.bcsdk.BcBlock.prototype.getTxDistanceSumLimit = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 28, 0)
  );
};
/** @param {number} value */


proto.bcsdk.BcBlock.prototype.setTxDistanceSumLimit = function (value) {
  jspb.Message.setProto3IntField(this, 28, value);
};
/**
 * optional uint64 blockchain_headers_count = 29;
 * @return {number}
 */


proto.bcsdk.BcBlock.prototype.getBlockchainHeadersCount = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 29, 0)
  );
};
/** @param {number} value */


proto.bcsdk.BcBlock.prototype.setBlockchainHeadersCount = function (value) {
  jspb.Message.setProto3IntField(this, 29, value);
};
/**
 * optional BlockchainHeaders blockchain_headers = 30;
 * @return {?proto.bcsdk.BlockchainHeaders}
 */


proto.bcsdk.BcBlock.prototype.getBlockchainHeaders = function () {
  return (
    /** @type{?proto.bcsdk.BlockchainHeaders} */
    jspb.Message.getWrapperField(this, proto.bcsdk.BlockchainHeaders, 30)
  );
};
/** @param {?proto.bcsdk.BlockchainHeaders|undefined} value */


proto.bcsdk.BcBlock.prototype.setBlockchainHeaders = function (value) {
  jspb.Message.setWrapperField(this, 30, value);
};

proto.bcsdk.BcBlock.prototype.clearBlockchainHeaders = function () {
  this.setBlockchainHeaders(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.bcsdk.BcBlock.prototype.hasBlockchainHeaders = function () {
  return jspb.Message.getField(this, 30) != null;
};
/**
 * optional string blockchain_fingerprints_root = 31;
 * @return {string}
 */


proto.bcsdk.BcBlock.prototype.getBlockchainFingerprintsRoot = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 31, "")
  );
};
/** @param {string} value */


proto.bcsdk.BcBlock.prototype.setBlockchainFingerprintsRoot = function (value) {
  jspb.Message.setProto3StringField(this, 31, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.OutPoint = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.OutPoint, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.OutPoint.displayName = 'proto.bcsdk.OutPoint';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.OutPoint.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.OutPoint.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.OutPoint} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.OutPoint.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      value: msg.getValue_asB64(),
      hash: jspb.Message.getFieldWithDefault(msg, 2, ""),
      index: jspb.Message.getFieldWithDefault(msg, 3, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.OutPoint}
 */


proto.bcsdk.OutPoint.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.OutPoint();
  return proto.bcsdk.OutPoint.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.OutPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.OutPoint}
 */


proto.bcsdk.OutPoint.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {!Uint8Array} */
        reader.readBytes();
        msg.setValue(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setHash(value);
        break;

      case 3:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setIndex(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.OutPoint.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.OutPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.OutPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.OutPoint.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getValue_asU8();

  if (f.length > 0) {
    writer.writeBytes(1, f);
  }

  f = message.getHash();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getIndex();

  if (f !== 0) {
    writer.writeUint64(3, f);
  }
};
/**
 * optional bytes value = 1;
 * @return {!(string|Uint8Array)}
 */


proto.bcsdk.OutPoint.prototype.getValue = function () {
  return (
    /** @type {!(string|Uint8Array)} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * optional bytes value = 1;
 * This is a type-conversion wrapper around `getValue()`
 * @return {string}
 */


proto.bcsdk.OutPoint.prototype.getValue_asB64 = function () {
  return (
    /** @type {string} */
    jspb.Message.bytesAsB64(this.getValue())
  );
};
/**
 * optional bytes value = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getValue()`
 * @return {!Uint8Array}
 */


proto.bcsdk.OutPoint.prototype.getValue_asU8 = function () {
  return (
    /** @type {!Uint8Array} */
    jspb.Message.bytesAsU8(this.getValue())
  );
};
/** @param {!(string|Uint8Array)} value */


proto.bcsdk.OutPoint.prototype.setValue = function (value) {
  jspb.Message.setProto3BytesField(this, 1, value);
};
/**
 * optional string hash = 2;
 * @return {string}
 */


proto.bcsdk.OutPoint.prototype.getHash = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.bcsdk.OutPoint.prototype.setHash = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional uint64 index = 3;
 * @return {number}
 */


proto.bcsdk.OutPoint.prototype.getIndex = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {number} value */


proto.bcsdk.OutPoint.prototype.setIndex = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.WalletOutPoint = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.WalletOutPoint, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.WalletOutPoint.displayName = 'proto.bcsdk.WalletOutPoint';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.WalletOutPoint.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.WalletOutPoint.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.WalletOutPoint} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.WalletOutPoint.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      outpoint: (f = msg.getOutpoint()) && proto.bcsdk.OutPoint.toObject(includeInstance, f),
      callbackScript: msg.getCallbackScript_asB64(),
      originalScript: msg.getOriginalScript_asB64(),
      blockHeight: jspb.Message.getFieldWithDefault(msg, 4, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.WalletOutPoint}
 */


proto.bcsdk.WalletOutPoint.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.WalletOutPoint();
  return proto.bcsdk.WalletOutPoint.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.WalletOutPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.WalletOutPoint}
 */


proto.bcsdk.WalletOutPoint.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.bcsdk.OutPoint();
        reader.readMessage(value, proto.bcsdk.OutPoint.deserializeBinaryFromReader);
        msg.setOutpoint(value);
        break;

      case 2:
        var value =
        /** @type {!Uint8Array} */
        reader.readBytes();
        msg.setCallbackScript(value);
        break;

      case 3:
        var value =
        /** @type {!Uint8Array} */
        reader.readBytes();
        msg.setOriginalScript(value);
        break;

      case 4:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setBlockHeight(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.WalletOutPoint.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.WalletOutPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.WalletOutPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.WalletOutPoint.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getOutpoint();

  if (f != null) {
    writer.writeMessage(1, f, proto.bcsdk.OutPoint.serializeBinaryToWriter);
  }

  f = message.getCallbackScript_asU8();

  if (f.length > 0) {
    writer.writeBytes(2, f);
  }

  f = message.getOriginalScript_asU8();

  if (f.length > 0) {
    writer.writeBytes(3, f);
  }

  f = message.getBlockHeight();

  if (f !== 0) {
    writer.writeUint64(4, f);
  }
};
/**
 * optional OutPoint outpoint = 1;
 * @return {?proto.bcsdk.OutPoint}
 */


proto.bcsdk.WalletOutPoint.prototype.getOutpoint = function () {
  return (
    /** @type{?proto.bcsdk.OutPoint} */
    jspb.Message.getWrapperField(this, proto.bcsdk.OutPoint, 1)
  );
};
/** @param {?proto.bcsdk.OutPoint|undefined} value */


proto.bcsdk.WalletOutPoint.prototype.setOutpoint = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

proto.bcsdk.WalletOutPoint.prototype.clearOutpoint = function () {
  this.setOutpoint(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.bcsdk.WalletOutPoint.prototype.hasOutpoint = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * optional bytes callback_script = 2;
 * @return {!(string|Uint8Array)}
 */


proto.bcsdk.WalletOutPoint.prototype.getCallbackScript = function () {
  return (
    /** @type {!(string|Uint8Array)} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * optional bytes callback_script = 2;
 * This is a type-conversion wrapper around `getCallbackScript()`
 * @return {string}
 */


proto.bcsdk.WalletOutPoint.prototype.getCallbackScript_asB64 = function () {
  return (
    /** @type {string} */
    jspb.Message.bytesAsB64(this.getCallbackScript())
  );
};
/**
 * optional bytes callback_script = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCallbackScript()`
 * @return {!Uint8Array}
 */


proto.bcsdk.WalletOutPoint.prototype.getCallbackScript_asU8 = function () {
  return (
    /** @type {!Uint8Array} */
    jspb.Message.bytesAsU8(this.getCallbackScript())
  );
};
/** @param {!(string|Uint8Array)} value */


proto.bcsdk.WalletOutPoint.prototype.setCallbackScript = function (value) {
  jspb.Message.setProto3BytesField(this, 2, value);
};
/**
 * optional bytes original_script = 3;
 * @return {!(string|Uint8Array)}
 */


proto.bcsdk.WalletOutPoint.prototype.getOriginalScript = function () {
  return (
    /** @type {!(string|Uint8Array)} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/**
 * optional bytes original_script = 3;
 * This is a type-conversion wrapper around `getOriginalScript()`
 * @return {string}
 */


proto.bcsdk.WalletOutPoint.prototype.getOriginalScript_asB64 = function () {
  return (
    /** @type {string} */
    jspb.Message.bytesAsB64(this.getOriginalScript())
  );
};
/**
 * optional bytes original_script = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getOriginalScript()`
 * @return {!Uint8Array}
 */


proto.bcsdk.WalletOutPoint.prototype.getOriginalScript_asU8 = function () {
  return (
    /** @type {!Uint8Array} */
    jspb.Message.bytesAsU8(this.getOriginalScript())
  );
};
/** @param {!(string|Uint8Array)} value */


proto.bcsdk.WalletOutPoint.prototype.setOriginalScript = function (value) {
  jspb.Message.setProto3BytesField(this, 3, value);
};
/**
 * optional uint64 block_height = 4;
 * @return {number}
 */


proto.bcsdk.WalletOutPoint.prototype.getBlockHeight = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 4, 0)
  );
};
/** @param {number} value */


proto.bcsdk.WalletOutPoint.prototype.setBlockHeight = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.WalletData = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.bcsdk.WalletData.repeatedFields_, null);
};

goog.inherits(proto.bcsdk.WalletData, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.WalletData.displayName = 'proto.bcsdk.WalletData';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.bcsdk.WalletData.repeatedFields_ = [3, 4, 5, 6, 7, 8];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.WalletData.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.WalletData.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.WalletData} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.WalletData.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      blockHeight: jspb.Message.getFieldWithDefault(msg, 1, 0),
      blockHash: jspb.Message.getFieldWithDefault(msg, 2, ""),
      unconfirmedSpendableOutpointsList: jspb.Message.toObjectList(msg.getUnconfirmedSpendableOutpointsList(), proto.bcsdk.WalletOutPoint.toObject, includeInstance),
      spendableOutpointsList: jspb.Message.toObjectList(msg.getSpendableOutpointsList(), proto.bcsdk.WalletOutPoint.toObject, includeInstance),
      collateralizedMakerOutpointsList: jspb.Message.toObjectList(msg.getCollateralizedMakerOutpointsList(), proto.bcsdk.WalletOutPoint.toObject, includeInstance),
      collateralizedUnmatchedOutpointsList: jspb.Message.toObjectList(msg.getCollateralizedUnmatchedOutpointsList(), proto.bcsdk.WalletOutPoint.toObject, includeInstance),
      collateralizedMatchedOutpointsList: jspb.Message.toObjectList(msg.getCollateralizedMatchedOutpointsList(), proto.bcsdk.WalletOutPoint.toObject, includeInstance),
      collateralizedSpendableOutpointsList: jspb.Message.toObjectList(msg.getCollateralizedSpendableOutpointsList(), proto.bcsdk.WalletOutPoint.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.WalletData}
 */


proto.bcsdk.WalletData.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.WalletData();
  return proto.bcsdk.WalletData.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.WalletData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.WalletData}
 */


proto.bcsdk.WalletData.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setBlockHeight(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setBlockHash(value);
        break;

      case 3:
        var value = new proto.bcsdk.WalletOutPoint();
        reader.readMessage(value, proto.bcsdk.WalletOutPoint.deserializeBinaryFromReader);
        msg.addUnconfirmedSpendableOutpoints(value);
        break;

      case 4:
        var value = new proto.bcsdk.WalletOutPoint();
        reader.readMessage(value, proto.bcsdk.WalletOutPoint.deserializeBinaryFromReader);
        msg.addSpendableOutpoints(value);
        break;

      case 5:
        var value = new proto.bcsdk.WalletOutPoint();
        reader.readMessage(value, proto.bcsdk.WalletOutPoint.deserializeBinaryFromReader);
        msg.addCollateralizedMakerOutpoints(value);
        break;

      case 6:
        var value = new proto.bcsdk.WalletOutPoint();
        reader.readMessage(value, proto.bcsdk.WalletOutPoint.deserializeBinaryFromReader);
        msg.addCollateralizedUnmatchedOutpoints(value);
        break;

      case 7:
        var value = new proto.bcsdk.WalletOutPoint();
        reader.readMessage(value, proto.bcsdk.WalletOutPoint.deserializeBinaryFromReader);
        msg.addCollateralizedMatchedOutpoints(value);
        break;

      case 8:
        var value = new proto.bcsdk.WalletOutPoint();
        reader.readMessage(value, proto.bcsdk.WalletOutPoint.deserializeBinaryFromReader);
        msg.addCollateralizedSpendableOutpoints(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.WalletData.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.WalletData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.WalletData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.WalletData.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getBlockHeight();

  if (f !== 0) {
    writer.writeUint64(1, f);
  }

  f = message.getBlockHash();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getUnconfirmedSpendableOutpointsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(3, f, proto.bcsdk.WalletOutPoint.serializeBinaryToWriter);
  }

  f = message.getSpendableOutpointsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(4, f, proto.bcsdk.WalletOutPoint.serializeBinaryToWriter);
  }

  f = message.getCollateralizedMakerOutpointsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(5, f, proto.bcsdk.WalletOutPoint.serializeBinaryToWriter);
  }

  f = message.getCollateralizedUnmatchedOutpointsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(6, f, proto.bcsdk.WalletOutPoint.serializeBinaryToWriter);
  }

  f = message.getCollateralizedMatchedOutpointsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(7, f, proto.bcsdk.WalletOutPoint.serializeBinaryToWriter);
  }

  f = message.getCollateralizedSpendableOutpointsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(8, f, proto.bcsdk.WalletOutPoint.serializeBinaryToWriter);
  }
};
/**
 * optional uint64 block_height = 1;
 * @return {number}
 */


proto.bcsdk.WalletData.prototype.getBlockHeight = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {number} value */


proto.bcsdk.WalletData.prototype.setBlockHeight = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional string block_hash = 2;
 * @return {string}
 */


proto.bcsdk.WalletData.prototype.getBlockHash = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.bcsdk.WalletData.prototype.setBlockHash = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * repeated WalletOutPoint unconfirmed_spendable_outpoints = 3;
 * @return {!Array<!proto.bcsdk.WalletOutPoint>}
 */


proto.bcsdk.WalletData.prototype.getUnconfirmedSpendableOutpointsList = function () {
  return (
    /** @type{!Array<!proto.bcsdk.WalletOutPoint>} */
    jspb.Message.getRepeatedWrapperField(this, proto.bcsdk.WalletOutPoint, 3)
  );
};
/** @param {!Array<!proto.bcsdk.WalletOutPoint>} value */


proto.bcsdk.WalletData.prototype.setUnconfirmedSpendableOutpointsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};
/**
 * @param {!proto.bcsdk.WalletOutPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.bcsdk.WalletOutPoint}
 */


proto.bcsdk.WalletData.prototype.addUnconfirmedSpendableOutpoints = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.bcsdk.WalletOutPoint, opt_index);
};

proto.bcsdk.WalletData.prototype.clearUnconfirmedSpendableOutpointsList = function () {
  this.setUnconfirmedSpendableOutpointsList([]);
};
/**
 * repeated WalletOutPoint spendable_outpoints = 4;
 * @return {!Array<!proto.bcsdk.WalletOutPoint>}
 */


proto.bcsdk.WalletData.prototype.getSpendableOutpointsList = function () {
  return (
    /** @type{!Array<!proto.bcsdk.WalletOutPoint>} */
    jspb.Message.getRepeatedWrapperField(this, proto.bcsdk.WalletOutPoint, 4)
  );
};
/** @param {!Array<!proto.bcsdk.WalletOutPoint>} value */


proto.bcsdk.WalletData.prototype.setSpendableOutpointsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 4, value);
};
/**
 * @param {!proto.bcsdk.WalletOutPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.bcsdk.WalletOutPoint}
 */


proto.bcsdk.WalletData.prototype.addSpendableOutpoints = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.bcsdk.WalletOutPoint, opt_index);
};

proto.bcsdk.WalletData.prototype.clearSpendableOutpointsList = function () {
  this.setSpendableOutpointsList([]);
};
/**
 * repeated WalletOutPoint collateralized_maker_outpoints = 5;
 * @return {!Array<!proto.bcsdk.WalletOutPoint>}
 */


proto.bcsdk.WalletData.prototype.getCollateralizedMakerOutpointsList = function () {
  return (
    /** @type{!Array<!proto.bcsdk.WalletOutPoint>} */
    jspb.Message.getRepeatedWrapperField(this, proto.bcsdk.WalletOutPoint, 5)
  );
};
/** @param {!Array<!proto.bcsdk.WalletOutPoint>} value */


proto.bcsdk.WalletData.prototype.setCollateralizedMakerOutpointsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 5, value);
};
/**
 * @param {!proto.bcsdk.WalletOutPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.bcsdk.WalletOutPoint}
 */


proto.bcsdk.WalletData.prototype.addCollateralizedMakerOutpoints = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.bcsdk.WalletOutPoint, opt_index);
};

proto.bcsdk.WalletData.prototype.clearCollateralizedMakerOutpointsList = function () {
  this.setCollateralizedMakerOutpointsList([]);
};
/**
 * repeated WalletOutPoint collateralized_unmatched_outpoints = 6;
 * @return {!Array<!proto.bcsdk.WalletOutPoint>}
 */


proto.bcsdk.WalletData.prototype.getCollateralizedUnmatchedOutpointsList = function () {
  return (
    /** @type{!Array<!proto.bcsdk.WalletOutPoint>} */
    jspb.Message.getRepeatedWrapperField(this, proto.bcsdk.WalletOutPoint, 6)
  );
};
/** @param {!Array<!proto.bcsdk.WalletOutPoint>} value */


proto.bcsdk.WalletData.prototype.setCollateralizedUnmatchedOutpointsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 6, value);
};
/**
 * @param {!proto.bcsdk.WalletOutPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.bcsdk.WalletOutPoint}
 */


proto.bcsdk.WalletData.prototype.addCollateralizedUnmatchedOutpoints = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.bcsdk.WalletOutPoint, opt_index);
};

proto.bcsdk.WalletData.prototype.clearCollateralizedUnmatchedOutpointsList = function () {
  this.setCollateralizedUnmatchedOutpointsList([]);
};
/**
 * repeated WalletOutPoint collateralized_matched_outpoints = 7;
 * @return {!Array<!proto.bcsdk.WalletOutPoint>}
 */


proto.bcsdk.WalletData.prototype.getCollateralizedMatchedOutpointsList = function () {
  return (
    /** @type{!Array<!proto.bcsdk.WalletOutPoint>} */
    jspb.Message.getRepeatedWrapperField(this, proto.bcsdk.WalletOutPoint, 7)
  );
};
/** @param {!Array<!proto.bcsdk.WalletOutPoint>} value */


proto.bcsdk.WalletData.prototype.setCollateralizedMatchedOutpointsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 7, value);
};
/**
 * @param {!proto.bcsdk.WalletOutPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.bcsdk.WalletOutPoint}
 */


proto.bcsdk.WalletData.prototype.addCollateralizedMatchedOutpoints = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.bcsdk.WalletOutPoint, opt_index);
};

proto.bcsdk.WalletData.prototype.clearCollateralizedMatchedOutpointsList = function () {
  this.setCollateralizedMatchedOutpointsList([]);
};
/**
 * repeated WalletOutPoint collateralized_spendable_outpoints = 8;
 * @return {!Array<!proto.bcsdk.WalletOutPoint>}
 */


proto.bcsdk.WalletData.prototype.getCollateralizedSpendableOutpointsList = function () {
  return (
    /** @type{!Array<!proto.bcsdk.WalletOutPoint>} */
    jspb.Message.getRepeatedWrapperField(this, proto.bcsdk.WalletOutPoint, 8)
  );
};
/** @param {!Array<!proto.bcsdk.WalletOutPoint>} value */


proto.bcsdk.WalletData.prototype.setCollateralizedSpendableOutpointsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 8, value);
};
/**
 * @param {!proto.bcsdk.WalletOutPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.bcsdk.WalletOutPoint}
 */


proto.bcsdk.WalletData.prototype.addCollateralizedSpendableOutpoints = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.bcsdk.WalletOutPoint, opt_index);
};

proto.bcsdk.WalletData.prototype.clearCollateralizedSpendableOutpointsList = function () {
  this.setCollateralizedSpendableOutpointsList([]);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.OpenOrder = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.OpenOrder, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.OpenOrder.displayName = 'proto.bcsdk.OpenOrder';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.OpenOrder.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.OpenOrder.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.OpenOrder} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.OpenOrder.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      outpoint: (f = msg.getOutpoint()) && proto.bcsdk.OutPoint.toObject(includeInstance, f),
      originalValue: msg.getOriginalValue_asB64(),
      script: msg.getScript_asB64(),
      unit: msg.getUnit_asB64(),
      blockHeight: jspb.Message.getFieldWithDefault(msg, 5, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.OpenOrder}
 */


proto.bcsdk.OpenOrder.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.OpenOrder();
  return proto.bcsdk.OpenOrder.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.OpenOrder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.OpenOrder}
 */


proto.bcsdk.OpenOrder.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.bcsdk.OutPoint();
        reader.readMessage(value, proto.bcsdk.OutPoint.deserializeBinaryFromReader);
        msg.setOutpoint(value);
        break;

      case 2:
        var value =
        /** @type {!Uint8Array} */
        reader.readBytes();
        msg.setOriginalValue(value);
        break;

      case 3:
        var value =
        /** @type {!Uint8Array} */
        reader.readBytes();
        msg.setScript(value);
        break;

      case 4:
        var value =
        /** @type {!Uint8Array} */
        reader.readBytes();
        msg.setUnit(value);
        break;

      case 5:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setBlockHeight(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.OpenOrder.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.OpenOrder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.OpenOrder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.OpenOrder.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getOutpoint();

  if (f != null) {
    writer.writeMessage(1, f, proto.bcsdk.OutPoint.serializeBinaryToWriter);
  }

  f = message.getOriginalValue_asU8();

  if (f.length > 0) {
    writer.writeBytes(2, f);
  }

  f = message.getScript_asU8();

  if (f.length > 0) {
    writer.writeBytes(3, f);
  }

  f = message.getUnit_asU8();

  if (f.length > 0) {
    writer.writeBytes(4, f);
  }

  f = message.getBlockHeight();

  if (f !== 0) {
    writer.writeUint64(5, f);
  }
};
/**
 * optional OutPoint outpoint = 1;
 * @return {?proto.bcsdk.OutPoint}
 */


proto.bcsdk.OpenOrder.prototype.getOutpoint = function () {
  return (
    /** @type{?proto.bcsdk.OutPoint} */
    jspb.Message.getWrapperField(this, proto.bcsdk.OutPoint, 1)
  );
};
/** @param {?proto.bcsdk.OutPoint|undefined} value */


proto.bcsdk.OpenOrder.prototype.setOutpoint = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

proto.bcsdk.OpenOrder.prototype.clearOutpoint = function () {
  this.setOutpoint(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.bcsdk.OpenOrder.prototype.hasOutpoint = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * optional bytes original_value = 2;
 * @return {!(string|Uint8Array)}
 */


proto.bcsdk.OpenOrder.prototype.getOriginalValue = function () {
  return (
    /** @type {!(string|Uint8Array)} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * optional bytes original_value = 2;
 * This is a type-conversion wrapper around `getOriginalValue()`
 * @return {string}
 */


proto.bcsdk.OpenOrder.prototype.getOriginalValue_asB64 = function () {
  return (
    /** @type {string} */
    jspb.Message.bytesAsB64(this.getOriginalValue())
  );
};
/**
 * optional bytes original_value = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getOriginalValue()`
 * @return {!Uint8Array}
 */


proto.bcsdk.OpenOrder.prototype.getOriginalValue_asU8 = function () {
  return (
    /** @type {!Uint8Array} */
    jspb.Message.bytesAsU8(this.getOriginalValue())
  );
};
/** @param {!(string|Uint8Array)} value */


proto.bcsdk.OpenOrder.prototype.setOriginalValue = function (value) {
  jspb.Message.setProto3BytesField(this, 2, value);
};
/**
 * optional bytes script = 3;
 * @return {!(string|Uint8Array)}
 */


proto.bcsdk.OpenOrder.prototype.getScript = function () {
  return (
    /** @type {!(string|Uint8Array)} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/**
 * optional bytes script = 3;
 * This is a type-conversion wrapper around `getScript()`
 * @return {string}
 */


proto.bcsdk.OpenOrder.prototype.getScript_asB64 = function () {
  return (
    /** @type {string} */
    jspb.Message.bytesAsB64(this.getScript())
  );
};
/**
 * optional bytes script = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getScript()`
 * @return {!Uint8Array}
 */


proto.bcsdk.OpenOrder.prototype.getScript_asU8 = function () {
  return (
    /** @type {!Uint8Array} */
    jspb.Message.bytesAsU8(this.getScript())
  );
};
/** @param {!(string|Uint8Array)} value */


proto.bcsdk.OpenOrder.prototype.setScript = function (value) {
  jspb.Message.setProto3BytesField(this, 3, value);
};
/**
 * optional bytes unit = 4;
 * @return {!(string|Uint8Array)}
 */


proto.bcsdk.OpenOrder.prototype.getUnit = function () {
  return (
    /** @type {!(string|Uint8Array)} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/**
 * optional bytes unit = 4;
 * This is a type-conversion wrapper around `getUnit()`
 * @return {string}
 */


proto.bcsdk.OpenOrder.prototype.getUnit_asB64 = function () {
  return (
    /** @type {string} */
    jspb.Message.bytesAsB64(this.getUnit())
  );
};
/**
 * optional bytes unit = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getUnit()`
 * @return {!Uint8Array}
 */


proto.bcsdk.OpenOrder.prototype.getUnit_asU8 = function () {
  return (
    /** @type {!Uint8Array} */
    jspb.Message.bytesAsU8(this.getUnit())
  );
};
/** @param {!(string|Uint8Array)} value */


proto.bcsdk.OpenOrder.prototype.setUnit = function (value) {
  jspb.Message.setProto3BytesField(this, 4, value);
};
/**
 * optional uint64 block_height = 5;
 * @return {number}
 */


proto.bcsdk.OpenOrder.prototype.getBlockHeight = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 5, 0)
  );
};
/** @param {number} value */


proto.bcsdk.OpenOrder.prototype.setBlockHeight = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.MatchedOrder = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.MatchedOrder, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.MatchedOrder.displayName = 'proto.bcsdk.MatchedOrder';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.MatchedOrder.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.MatchedOrder.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.MatchedOrder} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.MatchedOrder.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      takerOutpoint: (f = msg.getTakerOutpoint()) && proto.bcsdk.OutPoint.toObject(includeInstance, f),
      takerOutputScript: msg.getTakerOutputScript_asB64(),
      takerInputScript: msg.getTakerInputScript_asB64(),
      makerOrder: (f = msg.getMakerOrder()) && proto.bcsdk.OpenOrder.toObject(includeInstance, f),
      blockHeightTaker: jspb.Message.getFieldWithDefault(msg, 5, 0),
      timestamp: jspb.Message.getFieldWithDefault(msg, 6, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.MatchedOrder}
 */


proto.bcsdk.MatchedOrder.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.MatchedOrder();
  return proto.bcsdk.MatchedOrder.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.MatchedOrder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.MatchedOrder}
 */


proto.bcsdk.MatchedOrder.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.bcsdk.OutPoint();
        reader.readMessage(value, proto.bcsdk.OutPoint.deserializeBinaryFromReader);
        msg.setTakerOutpoint(value);
        break;

      case 2:
        var value =
        /** @type {!Uint8Array} */
        reader.readBytes();
        msg.setTakerOutputScript(value);
        break;

      case 3:
        var value =
        /** @type {!Uint8Array} */
        reader.readBytes();
        msg.setTakerInputScript(value);
        break;

      case 4:
        var value = new proto.bcsdk.OpenOrder();
        reader.readMessage(value, proto.bcsdk.OpenOrder.deserializeBinaryFromReader);
        msg.setMakerOrder(value);
        break;

      case 5:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setBlockHeightTaker(value);
        break;

      case 6:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setTimestamp(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.MatchedOrder.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.MatchedOrder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.MatchedOrder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.MatchedOrder.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTakerOutpoint();

  if (f != null) {
    writer.writeMessage(1, f, proto.bcsdk.OutPoint.serializeBinaryToWriter);
  }

  f = message.getTakerOutputScript_asU8();

  if (f.length > 0) {
    writer.writeBytes(2, f);
  }

  f = message.getTakerInputScript_asU8();

  if (f.length > 0) {
    writer.writeBytes(3, f);
  }

  f = message.getMakerOrder();

  if (f != null) {
    writer.writeMessage(4, f, proto.bcsdk.OpenOrder.serializeBinaryToWriter);
  }

  f = message.getBlockHeightTaker();

  if (f !== 0) {
    writer.writeUint64(5, f);
  }

  f = message.getTimestamp();

  if (f !== 0) {
    writer.writeUint64(6, f);
  }
};
/**
 * optional OutPoint taker_outpoint = 1;
 * @return {?proto.bcsdk.OutPoint}
 */


proto.bcsdk.MatchedOrder.prototype.getTakerOutpoint = function () {
  return (
    /** @type{?proto.bcsdk.OutPoint} */
    jspb.Message.getWrapperField(this, proto.bcsdk.OutPoint, 1)
  );
};
/** @param {?proto.bcsdk.OutPoint|undefined} value */


proto.bcsdk.MatchedOrder.prototype.setTakerOutpoint = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

proto.bcsdk.MatchedOrder.prototype.clearTakerOutpoint = function () {
  this.setTakerOutpoint(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.bcsdk.MatchedOrder.prototype.hasTakerOutpoint = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * optional bytes taker_output_script = 2;
 * @return {!(string|Uint8Array)}
 */


proto.bcsdk.MatchedOrder.prototype.getTakerOutputScript = function () {
  return (
    /** @type {!(string|Uint8Array)} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * optional bytes taker_output_script = 2;
 * This is a type-conversion wrapper around `getTakerOutputScript()`
 * @return {string}
 */


proto.bcsdk.MatchedOrder.prototype.getTakerOutputScript_asB64 = function () {
  return (
    /** @type {string} */
    jspb.Message.bytesAsB64(this.getTakerOutputScript())
  );
};
/**
 * optional bytes taker_output_script = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getTakerOutputScript()`
 * @return {!Uint8Array}
 */


proto.bcsdk.MatchedOrder.prototype.getTakerOutputScript_asU8 = function () {
  return (
    /** @type {!Uint8Array} */
    jspb.Message.bytesAsU8(this.getTakerOutputScript())
  );
};
/** @param {!(string|Uint8Array)} value */


proto.bcsdk.MatchedOrder.prototype.setTakerOutputScript = function (value) {
  jspb.Message.setProto3BytesField(this, 2, value);
};
/**
 * optional bytes taker_input_script = 3;
 * @return {!(string|Uint8Array)}
 */


proto.bcsdk.MatchedOrder.prototype.getTakerInputScript = function () {
  return (
    /** @type {!(string|Uint8Array)} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/**
 * optional bytes taker_input_script = 3;
 * This is a type-conversion wrapper around `getTakerInputScript()`
 * @return {string}
 */


proto.bcsdk.MatchedOrder.prototype.getTakerInputScript_asB64 = function () {
  return (
    /** @type {string} */
    jspb.Message.bytesAsB64(this.getTakerInputScript())
  );
};
/**
 * optional bytes taker_input_script = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getTakerInputScript()`
 * @return {!Uint8Array}
 */


proto.bcsdk.MatchedOrder.prototype.getTakerInputScript_asU8 = function () {
  return (
    /** @type {!Uint8Array} */
    jspb.Message.bytesAsU8(this.getTakerInputScript())
  );
};
/** @param {!(string|Uint8Array)} value */


proto.bcsdk.MatchedOrder.prototype.setTakerInputScript = function (value) {
  jspb.Message.setProto3BytesField(this, 3, value);
};
/**
 * optional OpenOrder maker_order = 4;
 * @return {?proto.bcsdk.OpenOrder}
 */


proto.bcsdk.MatchedOrder.prototype.getMakerOrder = function () {
  return (
    /** @type{?proto.bcsdk.OpenOrder} */
    jspb.Message.getWrapperField(this, proto.bcsdk.OpenOrder, 4)
  );
};
/** @param {?proto.bcsdk.OpenOrder|undefined} value */


proto.bcsdk.MatchedOrder.prototype.setMakerOrder = function (value) {
  jspb.Message.setWrapperField(this, 4, value);
};

proto.bcsdk.MatchedOrder.prototype.clearMakerOrder = function () {
  this.setMakerOrder(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.bcsdk.MatchedOrder.prototype.hasMakerOrder = function () {
  return jspb.Message.getField(this, 4) != null;
};
/**
 * optional uint64 block_height_taker = 5;
 * @return {number}
 */


proto.bcsdk.MatchedOrder.prototype.getBlockHeightTaker = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 5, 0)
  );
};
/** @param {number} value */


proto.bcsdk.MatchedOrder.prototype.setBlockHeightTaker = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};
/**
 * optional uint64 timestamp = 6;
 * @return {number}
 */


proto.bcsdk.MatchedOrder.prototype.getTimestamp = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 6, 0)
  );
};
/** @param {number} value */


proto.bcsdk.MatchedOrder.prototype.setTimestamp = function (value) {
  jspb.Message.setProto3IntField(this, 6, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.HistoricalOrder = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.HistoricalOrder, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.HistoricalOrder.displayName = 'proto.bcsdk.HistoricalOrder';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.HistoricalOrder.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.HistoricalOrder.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.HistoricalOrder} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.HistoricalOrder.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      order: (f = msg.getOrder()) && proto.bcsdk.MatchedOrder.toObject(includeInstance, f),
      takerSettled: jspb.Message.getFieldWithDefault(msg, 2, false),
      makerSettled: jspb.Message.getFieldWithDefault(msg, 3, false),
      unlocked: jspb.Message.getFieldWithDefault(msg, 4, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.HistoricalOrder}
 */


proto.bcsdk.HistoricalOrder.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.HistoricalOrder();
  return proto.bcsdk.HistoricalOrder.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.HistoricalOrder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.HistoricalOrder}
 */


proto.bcsdk.HistoricalOrder.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.bcsdk.MatchedOrder();
        reader.readMessage(value, proto.bcsdk.MatchedOrder.deserializeBinaryFromReader);
        msg.setOrder(value);
        break;

      case 2:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setTakerSettled(value);
        break;

      case 3:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setMakerSettled(value);
        break;

      case 4:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setUnlocked(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.HistoricalOrder.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.HistoricalOrder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.HistoricalOrder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.HistoricalOrder.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getOrder();

  if (f != null) {
    writer.writeMessage(1, f, proto.bcsdk.MatchedOrder.serializeBinaryToWriter);
  }

  f = message.getTakerSettled();

  if (f) {
    writer.writeBool(2, f);
  }

  f = message.getMakerSettled();

  if (f) {
    writer.writeBool(3, f);
  }

  f = message.getUnlocked();

  if (f) {
    writer.writeBool(4, f);
  }
};
/**
 * optional MatchedOrder order = 1;
 * @return {?proto.bcsdk.MatchedOrder}
 */


proto.bcsdk.HistoricalOrder.prototype.getOrder = function () {
  return (
    /** @type{?proto.bcsdk.MatchedOrder} */
    jspb.Message.getWrapperField(this, proto.bcsdk.MatchedOrder, 1)
  );
};
/** @param {?proto.bcsdk.MatchedOrder|undefined} value */


proto.bcsdk.HistoricalOrder.prototype.setOrder = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

proto.bcsdk.HistoricalOrder.prototype.clearOrder = function () {
  this.setOrder(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.bcsdk.HistoricalOrder.prototype.hasOrder = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * optional bool taker_settled = 2;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */


proto.bcsdk.HistoricalOrder.prototype.getTakerSettled = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getFieldWithDefault(this, 2, false)
  );
};
/** @param {boolean} value */


proto.bcsdk.HistoricalOrder.prototype.setTakerSettled = function (value) {
  jspb.Message.setProto3BooleanField(this, 2, value);
};
/**
 * optional bool maker_settled = 3;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */


proto.bcsdk.HistoricalOrder.prototype.getMakerSettled = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getFieldWithDefault(this, 3, false)
  );
};
/** @param {boolean} value */


proto.bcsdk.HistoricalOrder.prototype.setMakerSettled = function (value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};
/**
 * optional bool unlocked = 4;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */


proto.bcsdk.HistoricalOrder.prototype.getUnlocked = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getFieldWithDefault(this, 4, false)
  );
};
/** @param {boolean} value */


proto.bcsdk.HistoricalOrder.prototype.setUnlocked = function (value) {
  jspb.Message.setProto3BooleanField(this, 4, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.MatchedTx = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.MatchedTx, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.MatchedTx.displayName = 'proto.bcsdk.MatchedTx';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.MatchedTx.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.MatchedTx.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.MatchedTx} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.MatchedTx.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      hash: jspb.Message.getFieldWithDefault(msg, 1, ""),
      outputIndex: jspb.Message.getFieldWithDefault(msg, 2, 0),
      chain: jspb.Message.getFieldWithDefault(msg, 3, ""),
      sendsFrom: jspb.Message.getFieldWithDefault(msg, 4, ""),
      receivesTo: jspb.Message.getFieldWithDefault(msg, 5, ""),
      amount: jspb.Message.getFieldWithDefault(msg, 6, ""),
      isMaker: jspb.Message.getFieldWithDefault(msg, 7, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.MatchedTx}
 */


proto.bcsdk.MatchedTx.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.MatchedTx();
  return proto.bcsdk.MatchedTx.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.MatchedTx} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.MatchedTx}
 */


proto.bcsdk.MatchedTx.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setHash(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setOutputIndex(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setChain(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setSendsFrom(value);
        break;

      case 5:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setReceivesTo(value);
        break;

      case 6:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setAmount(value);
        break;

      case 7:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setIsMaker(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.MatchedTx.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.MatchedTx.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.MatchedTx} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.MatchedTx.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getHash();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getOutputIndex();

  if (f !== 0) {
    writer.writeUint32(2, f);
  }

  f = message.getChain();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getSendsFrom();

  if (f.length > 0) {
    writer.writeString(4, f);
  }

  f = message.getReceivesTo();

  if (f.length > 0) {
    writer.writeString(5, f);
  }

  f = message.getAmount();

  if (f.length > 0) {
    writer.writeString(6, f);
  }

  f = message.getIsMaker();

  if (f) {
    writer.writeBool(7, f);
  }
};
/**
 * optional string hash = 1;
 * @return {string}
 */


proto.bcsdk.MatchedTx.prototype.getHash = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.MatchedTx.prototype.setHash = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional uint32 output_index = 2;
 * @return {number}
 */


proto.bcsdk.MatchedTx.prototype.getOutputIndex = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {number} value */


proto.bcsdk.MatchedTx.prototype.setOutputIndex = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string chain = 3;
 * @return {string}
 */


proto.bcsdk.MatchedTx.prototype.getChain = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.bcsdk.MatchedTx.prototype.setChain = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string sends_from = 4;
 * @return {string}
 */


proto.bcsdk.MatchedTx.prototype.getSendsFrom = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/** @param {string} value */


proto.bcsdk.MatchedTx.prototype.setSendsFrom = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string receives_to = 5;
 * @return {string}
 */


proto.bcsdk.MatchedTx.prototype.getReceivesTo = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 5, "")
  );
};
/** @param {string} value */


proto.bcsdk.MatchedTx.prototype.setReceivesTo = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string amount = 6;
 * @return {string}
 */


proto.bcsdk.MatchedTx.prototype.getAmount = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 6, "")
  );
};
/** @param {string} value */


proto.bcsdk.MatchedTx.prototype.setAmount = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};
/**
 * optional bool is_maker = 7;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */


proto.bcsdk.MatchedTx.prototype.getIsMaker = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getFieldWithDefault(this, 7, false)
  );
};
/** @param {boolean} value */


proto.bcsdk.MatchedTx.prototype.setIsMaker = function (value) {
  jspb.Message.setProto3BooleanField(this, 7, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.MatchedTxs = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.bcsdk.MatchedTxs.repeatedFields_, null);
};

goog.inherits(proto.bcsdk.MatchedTxs, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.MatchedTxs.displayName = 'proto.bcsdk.MatchedTxs';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.bcsdk.MatchedTxs.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.MatchedTxs.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.MatchedTxs.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.MatchedTxs} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.MatchedTxs.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      txsList: jspb.Message.toObjectList(msg.getTxsList(), proto.bcsdk.MatchedTx.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.MatchedTxs}
 */


proto.bcsdk.MatchedTxs.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.MatchedTxs();
  return proto.bcsdk.MatchedTxs.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.MatchedTxs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.MatchedTxs}
 */


proto.bcsdk.MatchedTxs.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.bcsdk.MatchedTx();
        reader.readMessage(value, proto.bcsdk.MatchedTx.deserializeBinaryFromReader);
        msg.addTxs(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.MatchedTxs.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.MatchedTxs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.MatchedTxs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.MatchedTxs.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTxsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.bcsdk.MatchedTx.serializeBinaryToWriter);
  }
};
/**
 * repeated MatchedTx txs = 1;
 * @return {!Array<!proto.bcsdk.MatchedTx>}
 */


proto.bcsdk.MatchedTxs.prototype.getTxsList = function () {
  return (
    /** @type{!Array<!proto.bcsdk.MatchedTx>} */
    jspb.Message.getRepeatedWrapperField(this, proto.bcsdk.MatchedTx, 1)
  );
};
/** @param {!Array<!proto.bcsdk.MatchedTx>} value */


proto.bcsdk.MatchedTxs.prototype.setTxsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.bcsdk.MatchedTx=} opt_value
 * @param {number=} opt_index
 * @return {!proto.bcsdk.MatchedTx}
 */


proto.bcsdk.MatchedTxs.prototype.addTxs = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.bcsdk.MatchedTx, opt_index);
};

proto.bcsdk.MatchedTxs.prototype.clearTxsList = function () {
  this.setTxsList([]);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.Transaction = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.bcsdk.Transaction.repeatedFields_, null);
};

goog.inherits(proto.bcsdk.Transaction, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.Transaction.displayName = 'proto.bcsdk.Transaction';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.bcsdk.Transaction.repeatedFields_ = [7, 8];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.Transaction.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.Transaction.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.Transaction} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.Transaction.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      version: jspb.Message.getFieldWithDefault(msg, 1, 0),
      nonce: jspb.Message.getFieldWithDefault(msg, 2, ""),
      hash: jspb.Message.getFieldWithDefault(msg, 3, ""),
      overline: jspb.Message.getFieldWithDefault(msg, 4, ""),
      ninCount: jspb.Message.getFieldWithDefault(msg, 5, 0),
      noutCount: jspb.Message.getFieldWithDefault(msg, 6, 0),
      inputsList: jspb.Message.toObjectList(msg.getInputsList(), proto.bcsdk.TransactionInput.toObject, includeInstance),
      outputsList: jspb.Message.toObjectList(msg.getOutputsList(), proto.bcsdk.TransactionOutput.toObject, includeInstance),
      lockTime: jspb.Message.getFieldWithDefault(msg, 9, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.Transaction}
 */


proto.bcsdk.Transaction.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.Transaction();
  return proto.bcsdk.Transaction.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.Transaction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.Transaction}
 */


proto.bcsdk.Transaction.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setVersion(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setNonce(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setHash(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setOverline(value);
        break;

      case 5:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setNinCount(value);
        break;

      case 6:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setNoutCount(value);
        break;

      case 7:
        var value = new proto.bcsdk.TransactionInput();
        reader.readMessage(value, proto.bcsdk.TransactionInput.deserializeBinaryFromReader);
        msg.addInputs(value);
        break;

      case 8:
        var value = new proto.bcsdk.TransactionOutput();
        reader.readMessage(value, proto.bcsdk.TransactionOutput.deserializeBinaryFromReader);
        msg.addOutputs(value);
        break;

      case 9:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setLockTime(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.Transaction.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.Transaction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.Transaction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.Transaction.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getVersion();

  if (f !== 0) {
    writer.writeUint64(1, f);
  }

  f = message.getNonce();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getHash();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getOverline();

  if (f.length > 0) {
    writer.writeString(4, f);
  }

  f = message.getNinCount();

  if (f !== 0) {
    writer.writeUint64(5, f);
  }

  f = message.getNoutCount();

  if (f !== 0) {
    writer.writeUint64(6, f);
  }

  f = message.getInputsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(7, f, proto.bcsdk.TransactionInput.serializeBinaryToWriter);
  }

  f = message.getOutputsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(8, f, proto.bcsdk.TransactionOutput.serializeBinaryToWriter);
  }

  f = message.getLockTime();

  if (f !== 0) {
    writer.writeUint32(9, f);
  }
};
/**
 * optional uint64 version = 1;
 * @return {number}
 */


proto.bcsdk.Transaction.prototype.getVersion = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {number} value */


proto.bcsdk.Transaction.prototype.setVersion = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional string nonce = 2;
 * @return {string}
 */


proto.bcsdk.Transaction.prototype.getNonce = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.bcsdk.Transaction.prototype.setNonce = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string hash = 3;
 * @return {string}
 */


proto.bcsdk.Transaction.prototype.getHash = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.bcsdk.Transaction.prototype.setHash = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string overline = 4;
 * @return {string}
 */


proto.bcsdk.Transaction.prototype.getOverline = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/** @param {string} value */


proto.bcsdk.Transaction.prototype.setOverline = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional uint64 nin_count = 5;
 * @return {number}
 */


proto.bcsdk.Transaction.prototype.getNinCount = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 5, 0)
  );
};
/** @param {number} value */


proto.bcsdk.Transaction.prototype.setNinCount = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};
/**
 * optional uint64 nout_count = 6;
 * @return {number}
 */


proto.bcsdk.Transaction.prototype.getNoutCount = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 6, 0)
  );
};
/** @param {number} value */


proto.bcsdk.Transaction.prototype.setNoutCount = function (value) {
  jspb.Message.setProto3IntField(this, 6, value);
};
/**
 * repeated TransactionInput inputs = 7;
 * @return {!Array<!proto.bcsdk.TransactionInput>}
 */


proto.bcsdk.Transaction.prototype.getInputsList = function () {
  return (
    /** @type{!Array<!proto.bcsdk.TransactionInput>} */
    jspb.Message.getRepeatedWrapperField(this, proto.bcsdk.TransactionInput, 7)
  );
};
/** @param {!Array<!proto.bcsdk.TransactionInput>} value */


proto.bcsdk.Transaction.prototype.setInputsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 7, value);
};
/**
 * @param {!proto.bcsdk.TransactionInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.bcsdk.TransactionInput}
 */


proto.bcsdk.Transaction.prototype.addInputs = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.bcsdk.TransactionInput, opt_index);
};

proto.bcsdk.Transaction.prototype.clearInputsList = function () {
  this.setInputsList([]);
};
/**
 * repeated TransactionOutput outputs = 8;
 * @return {!Array<!proto.bcsdk.TransactionOutput>}
 */


proto.bcsdk.Transaction.prototype.getOutputsList = function () {
  return (
    /** @type{!Array<!proto.bcsdk.TransactionOutput>} */
    jspb.Message.getRepeatedWrapperField(this, proto.bcsdk.TransactionOutput, 8)
  );
};
/** @param {!Array<!proto.bcsdk.TransactionOutput>} value */


proto.bcsdk.Transaction.prototype.setOutputsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 8, value);
};
/**
 * @param {!proto.bcsdk.TransactionOutput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.bcsdk.TransactionOutput}
 */


proto.bcsdk.Transaction.prototype.addOutputs = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.bcsdk.TransactionOutput, opt_index);
};

proto.bcsdk.Transaction.prototype.clearOutputsList = function () {
  this.setOutputsList([]);
};
/**
 * optional uint32 lock_time = 9;
 * @return {number}
 */


proto.bcsdk.Transaction.prototype.getLockTime = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 9, 0)
  );
};
/** @param {number} value */


proto.bcsdk.Transaction.prototype.setLockTime = function (value) {
  jspb.Message.setProto3IntField(this, 9, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.UnspentTransactions = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.bcsdk.UnspentTransactions.repeatedFields_, null);
};

goog.inherits(proto.bcsdk.UnspentTransactions, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.UnspentTransactions.displayName = 'proto.bcsdk.UnspentTransactions';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.bcsdk.UnspentTransactions.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.UnspentTransactions.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.UnspentTransactions.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.UnspentTransactions} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.UnspentTransactions.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      utxoList: jspb.Message.getRepeatedField(msg, 1)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.UnspentTransactions}
 */


proto.bcsdk.UnspentTransactions.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.UnspentTransactions();
  return proto.bcsdk.UnspentTransactions.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.UnspentTransactions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.UnspentTransactions}
 */


proto.bcsdk.UnspentTransactions.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addUtxo(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.UnspentTransactions.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.UnspentTransactions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.UnspentTransactions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.UnspentTransactions.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUtxoList();

  if (f.length > 0) {
    writer.writeRepeatedString(1, f);
  }
};
/**
 * repeated string utxo = 1;
 * @return {!Array<string>}
 */


proto.bcsdk.UnspentTransactions.prototype.getUtxoList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 1)
  );
};
/** @param {!Array<string>} value */


proto.bcsdk.UnspentTransactions.prototype.setUtxoList = function (value) {
  jspb.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.bcsdk.UnspentTransactions.prototype.addUtxo = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};

proto.bcsdk.UnspentTransactions.prototype.clearUtxoList = function () {
  this.setUtxoList([]);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.TransactionInput = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.TransactionInput, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.TransactionInput.displayName = 'proto.bcsdk.TransactionInput';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.TransactionInput.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.TransactionInput.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.TransactionInput} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.TransactionInput.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      outPoint: (f = msg.getOutPoint()) && proto.bcsdk.OutPoint.toObject(includeInstance, f),
      scriptLength: jspb.Message.getFieldWithDefault(msg, 2, 0),
      inputScript: msg.getInputScript_asB64()
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.TransactionInput}
 */


proto.bcsdk.TransactionInput.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.TransactionInput();
  return proto.bcsdk.TransactionInput.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.TransactionInput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.TransactionInput}
 */


proto.bcsdk.TransactionInput.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.bcsdk.OutPoint();
        reader.readMessage(value, proto.bcsdk.OutPoint.deserializeBinaryFromReader);
        msg.setOutPoint(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setScriptLength(value);
        break;

      case 3:
        var value =
        /** @type {!Uint8Array} */
        reader.readBytes();
        msg.setInputScript(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.TransactionInput.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.TransactionInput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.TransactionInput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.TransactionInput.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getOutPoint();

  if (f != null) {
    writer.writeMessage(1, f, proto.bcsdk.OutPoint.serializeBinaryToWriter);
  }

  f = message.getScriptLength();

  if (f !== 0) {
    writer.writeUint32(2, f);
  }

  f = message.getInputScript_asU8();

  if (f.length > 0) {
    writer.writeBytes(3, f);
  }
};
/**
 * optional OutPoint out_point = 1;
 * @return {?proto.bcsdk.OutPoint}
 */


proto.bcsdk.TransactionInput.prototype.getOutPoint = function () {
  return (
    /** @type{?proto.bcsdk.OutPoint} */
    jspb.Message.getWrapperField(this, proto.bcsdk.OutPoint, 1)
  );
};
/** @param {?proto.bcsdk.OutPoint|undefined} value */


proto.bcsdk.TransactionInput.prototype.setOutPoint = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

proto.bcsdk.TransactionInput.prototype.clearOutPoint = function () {
  this.setOutPoint(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.bcsdk.TransactionInput.prototype.hasOutPoint = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * optional uint32 script_length = 2;
 * @return {number}
 */


proto.bcsdk.TransactionInput.prototype.getScriptLength = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {number} value */


proto.bcsdk.TransactionInput.prototype.setScriptLength = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional bytes input_script = 3;
 * @return {!(string|Uint8Array)}
 */


proto.bcsdk.TransactionInput.prototype.getInputScript = function () {
  return (
    /** @type {!(string|Uint8Array)} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/**
 * optional bytes input_script = 3;
 * This is a type-conversion wrapper around `getInputScript()`
 * @return {string}
 */


proto.bcsdk.TransactionInput.prototype.getInputScript_asB64 = function () {
  return (
    /** @type {string} */
    jspb.Message.bytesAsB64(this.getInputScript())
  );
};
/**
 * optional bytes input_script = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getInputScript()`
 * @return {!Uint8Array}
 */


proto.bcsdk.TransactionInput.prototype.getInputScript_asU8 = function () {
  return (
    /** @type {!Uint8Array} */
    jspb.Message.bytesAsU8(this.getInputScript())
  );
};
/** @param {!(string|Uint8Array)} value */


proto.bcsdk.TransactionInput.prototype.setInputScript = function (value) {
  jspb.Message.setProto3BytesField(this, 3, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.Utxo = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.Utxo, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.Utxo.displayName = 'proto.bcsdk.Utxo';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.Utxo.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.Utxo.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.Utxo} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.Utxo.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      output: (f = msg.getOutput()) && proto.bcsdk.TransactionOutput.toObject(includeInstance, f),
      txHash: jspb.Message.getFieldWithDefault(msg, 2, ""),
      txIndex: jspb.Message.getFieldWithDefault(msg, 3, 0),
      blockHash: jspb.Message.getFieldWithDefault(msg, 4, ""),
      blockHeight: jspb.Message.getFieldWithDefault(msg, 5, 0),
      coinbase: jspb.Message.getFieldWithDefault(msg, 6, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.Utxo}
 */


proto.bcsdk.Utxo.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.Utxo();
  return proto.bcsdk.Utxo.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.Utxo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.Utxo}
 */


proto.bcsdk.Utxo.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.bcsdk.TransactionOutput();
        reader.readMessage(value, proto.bcsdk.TransactionOutput.deserializeBinaryFromReader);
        msg.setOutput(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setTxHash(value);
        break;

      case 3:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setTxIndex(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setBlockHash(value);
        break;

      case 5:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setBlockHeight(value);
        break;

      case 6:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setCoinbase(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.Utxo.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.Utxo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.Utxo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.Utxo.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getOutput();

  if (f != null) {
    writer.writeMessage(1, f, proto.bcsdk.TransactionOutput.serializeBinaryToWriter);
  }

  f = message.getTxHash();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getTxIndex();

  if (f !== 0) {
    writer.writeUint64(3, f);
  }

  f = message.getBlockHash();

  if (f.length > 0) {
    writer.writeString(4, f);
  }

  f = message.getBlockHeight();

  if (f !== 0) {
    writer.writeUint64(5, f);
  }

  f = message.getCoinbase();

  if (f) {
    writer.writeBool(6, f);
  }
};
/**
 * optional TransactionOutput output = 1;
 * @return {?proto.bcsdk.TransactionOutput}
 */


proto.bcsdk.Utxo.prototype.getOutput = function () {
  return (
    /** @type{?proto.bcsdk.TransactionOutput} */
    jspb.Message.getWrapperField(this, proto.bcsdk.TransactionOutput, 1)
  );
};
/** @param {?proto.bcsdk.TransactionOutput|undefined} value */


proto.bcsdk.Utxo.prototype.setOutput = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

proto.bcsdk.Utxo.prototype.clearOutput = function () {
  this.setOutput(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.bcsdk.Utxo.prototype.hasOutput = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * optional string tx_hash = 2;
 * @return {string}
 */


proto.bcsdk.Utxo.prototype.getTxHash = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.bcsdk.Utxo.prototype.setTxHash = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional uint64 tx_index = 3;
 * @return {number}
 */


proto.bcsdk.Utxo.prototype.getTxIndex = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {number} value */


proto.bcsdk.Utxo.prototype.setTxIndex = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};
/**
 * optional string block_hash = 4;
 * @return {string}
 */


proto.bcsdk.Utxo.prototype.getBlockHash = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/** @param {string} value */


proto.bcsdk.Utxo.prototype.setBlockHash = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional uint64 block_height = 5;
 * @return {number}
 */


proto.bcsdk.Utxo.prototype.getBlockHeight = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 5, 0)
  );
};
/** @param {number} value */


proto.bcsdk.Utxo.prototype.setBlockHeight = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};
/**
 * optional bool coinbase = 6;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */


proto.bcsdk.Utxo.prototype.getCoinbase = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getFieldWithDefault(this, 6, false)
  );
};
/** @param {boolean} value */


proto.bcsdk.Utxo.prototype.setCoinbase = function (value) {
  jspb.Message.setProto3BooleanField(this, 6, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.TransactionOutput = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.TransactionOutput, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.TransactionOutput.displayName = 'proto.bcsdk.TransactionOutput';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.TransactionOutput.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.TransactionOutput.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.TransactionOutput} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.TransactionOutput.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      value: msg.getValue_asB64(),
      unit: msg.getUnit_asB64(),
      scriptLength: jspb.Message.getFieldWithDefault(msg, 3, 0),
      outputScript: msg.getOutputScript_asB64()
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.TransactionOutput}
 */


proto.bcsdk.TransactionOutput.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.TransactionOutput();
  return proto.bcsdk.TransactionOutput.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.TransactionOutput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.TransactionOutput}
 */


proto.bcsdk.TransactionOutput.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {!Uint8Array} */
        reader.readBytes();
        msg.setValue(value);
        break;

      case 2:
        var value =
        /** @type {!Uint8Array} */
        reader.readBytes();
        msg.setUnit(value);
        break;

      case 3:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setScriptLength(value);
        break;

      case 4:
        var value =
        /** @type {!Uint8Array} */
        reader.readBytes();
        msg.setOutputScript(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.TransactionOutput.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.TransactionOutput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.TransactionOutput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.TransactionOutput.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getValue_asU8();

  if (f.length > 0) {
    writer.writeBytes(1, f);
  }

  f = message.getUnit_asU8();

  if (f.length > 0) {
    writer.writeBytes(2, f);
  }

  f = message.getScriptLength();

  if (f !== 0) {
    writer.writeUint32(3, f);
  }

  f = message.getOutputScript_asU8();

  if (f.length > 0) {
    writer.writeBytes(4, f);
  }
};
/**
 * optional bytes value = 1;
 * @return {!(string|Uint8Array)}
 */


proto.bcsdk.TransactionOutput.prototype.getValue = function () {
  return (
    /** @type {!(string|Uint8Array)} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/**
 * optional bytes value = 1;
 * This is a type-conversion wrapper around `getValue()`
 * @return {string}
 */


proto.bcsdk.TransactionOutput.prototype.getValue_asB64 = function () {
  return (
    /** @type {string} */
    jspb.Message.bytesAsB64(this.getValue())
  );
};
/**
 * optional bytes value = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getValue()`
 * @return {!Uint8Array}
 */


proto.bcsdk.TransactionOutput.prototype.getValue_asU8 = function () {
  return (
    /** @type {!Uint8Array} */
    jspb.Message.bytesAsU8(this.getValue())
  );
};
/** @param {!(string|Uint8Array)} value */


proto.bcsdk.TransactionOutput.prototype.setValue = function (value) {
  jspb.Message.setProto3BytesField(this, 1, value);
};
/**
 * optional bytes unit = 2;
 * @return {!(string|Uint8Array)}
 */


proto.bcsdk.TransactionOutput.prototype.getUnit = function () {
  return (
    /** @type {!(string|Uint8Array)} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * optional bytes unit = 2;
 * This is a type-conversion wrapper around `getUnit()`
 * @return {string}
 */


proto.bcsdk.TransactionOutput.prototype.getUnit_asB64 = function () {
  return (
    /** @type {string} */
    jspb.Message.bytesAsB64(this.getUnit())
  );
};
/**
 * optional bytes unit = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getUnit()`
 * @return {!Uint8Array}
 */


proto.bcsdk.TransactionOutput.prototype.getUnit_asU8 = function () {
  return (
    /** @type {!Uint8Array} */
    jspb.Message.bytesAsU8(this.getUnit())
  );
};
/** @param {!(string|Uint8Array)} value */


proto.bcsdk.TransactionOutput.prototype.setUnit = function (value) {
  jspb.Message.setProto3BytesField(this, 2, value);
};
/**
 * optional uint32 script_length = 3;
 * @return {number}
 */


proto.bcsdk.TransactionOutput.prototype.getScriptLength = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {number} value */


proto.bcsdk.TransactionOutput.prototype.setScriptLength = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};
/**
 * optional bytes output_script = 4;
 * @return {!(string|Uint8Array)}
 */


proto.bcsdk.TransactionOutput.prototype.getOutputScript = function () {
  return (
    /** @type {!(string|Uint8Array)} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/**
 * optional bytes output_script = 4;
 * This is a type-conversion wrapper around `getOutputScript()`
 * @return {string}
 */


proto.bcsdk.TransactionOutput.prototype.getOutputScript_asB64 = function () {
  return (
    /** @type {string} */
    jspb.Message.bytesAsB64(this.getOutputScript())
  );
};
/**
 * optional bytes output_script = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getOutputScript()`
 * @return {!Uint8Array}
 */


proto.bcsdk.TransactionOutput.prototype.getOutputScript_asU8 = function () {
  return (
    /** @type {!Uint8Array} */
    jspb.Message.bytesAsU8(this.getOutputScript())
  );
};
/** @param {!(string|Uint8Array)} value */


proto.bcsdk.TransactionOutput.prototype.setOutputScript = function (value) {
  jspb.Message.setProto3BytesField(this, 4, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.BlockchainHeader = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.bcsdk.BlockchainHeader.repeatedFields_, null);
};

goog.inherits(proto.bcsdk.BlockchainHeader, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.BlockchainHeader.displayName = 'proto.bcsdk.BlockchainHeader';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.bcsdk.BlockchainHeader.repeatedFields_ = [8];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.BlockchainHeader.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.BlockchainHeader.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.BlockchainHeader} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.BlockchainHeader.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      blockchain: jspb.Message.getFieldWithDefault(msg, 1, ""),
      hash: jspb.Message.getFieldWithDefault(msg, 2, ""),
      previousHash: jspb.Message.getFieldWithDefault(msg, 3, ""),
      timestamp: jspb.Message.getFieldWithDefault(msg, 4, 0),
      height: jspb.Message.getFieldWithDefault(msg, 5, 0),
      merkleRoot: jspb.Message.getFieldWithDefault(msg, 6, ""),
      blockchainConfirmationsInParentCount: jspb.Message.getFieldWithDefault(msg, 7, 0),
      markedTxsList: jspb.Message.toObjectList(msg.getMarkedTxsList(), proto.bcsdk.MarkedTransaction.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.BlockchainHeader}
 */


proto.bcsdk.BlockchainHeader.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.BlockchainHeader();
  return proto.bcsdk.BlockchainHeader.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.BlockchainHeader} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.BlockchainHeader}
 */


proto.bcsdk.BlockchainHeader.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setBlockchain(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setHash(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPreviousHash(value);
        break;

      case 4:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setTimestamp(value);
        break;

      case 5:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setHeight(value);
        break;

      case 6:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setMerkleRoot(value);
        break;

      case 7:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setBlockchainConfirmationsInParentCount(value);
        break;

      case 8:
        var value = new proto.bcsdk.MarkedTransaction();
        reader.readMessage(value, proto.bcsdk.MarkedTransaction.deserializeBinaryFromReader);
        msg.addMarkedTxs(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.BlockchainHeader.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.BlockchainHeader.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.BlockchainHeader} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.BlockchainHeader.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getBlockchain();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getHash();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getPreviousHash();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getTimestamp();

  if (f !== 0) {
    writer.writeUint64(4, f);
  }

  f = message.getHeight();

  if (f !== 0) {
    writer.writeUint64(5, f);
  }

  f = message.getMerkleRoot();

  if (f.length > 0) {
    writer.writeString(6, f);
  }

  f = message.getBlockchainConfirmationsInParentCount();

  if (f !== 0) {
    writer.writeUint64(7, f);
  }

  f = message.getMarkedTxsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(8, f, proto.bcsdk.MarkedTransaction.serializeBinaryToWriter);
  }
};
/**
 * optional string blockchain = 1;
 * @return {string}
 */


proto.bcsdk.BlockchainHeader.prototype.getBlockchain = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.BlockchainHeader.prototype.setBlockchain = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string hash = 2;
 * @return {string}
 */


proto.bcsdk.BlockchainHeader.prototype.getHash = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.bcsdk.BlockchainHeader.prototype.setHash = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string previous_hash = 3;
 * @return {string}
 */


proto.bcsdk.BlockchainHeader.prototype.getPreviousHash = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.bcsdk.BlockchainHeader.prototype.setPreviousHash = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional uint64 timestamp = 4;
 * @return {number}
 */


proto.bcsdk.BlockchainHeader.prototype.getTimestamp = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 4, 0)
  );
};
/** @param {number} value */


proto.bcsdk.BlockchainHeader.prototype.setTimestamp = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};
/**
 * optional uint64 height = 5;
 * @return {number}
 */


proto.bcsdk.BlockchainHeader.prototype.getHeight = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 5, 0)
  );
};
/** @param {number} value */


proto.bcsdk.BlockchainHeader.prototype.setHeight = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};
/**
 * optional string merkle_root = 6;
 * @return {string}
 */


proto.bcsdk.BlockchainHeader.prototype.getMerkleRoot = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 6, "")
  );
};
/** @param {string} value */


proto.bcsdk.BlockchainHeader.prototype.setMerkleRoot = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};
/**
 * optional uint64 blockchain_confirmations_in_parent_count = 7;
 * @return {number}
 */


proto.bcsdk.BlockchainHeader.prototype.getBlockchainConfirmationsInParentCount = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 7, 0)
  );
};
/** @param {number} value */


proto.bcsdk.BlockchainHeader.prototype.setBlockchainConfirmationsInParentCount = function (value) {
  jspb.Message.setProto3IntField(this, 7, value);
};
/**
 * repeated MarkedTransaction marked_txs = 8;
 * @return {!Array<!proto.bcsdk.MarkedTransaction>}
 */


proto.bcsdk.BlockchainHeader.prototype.getMarkedTxsList = function () {
  return (
    /** @type{!Array<!proto.bcsdk.MarkedTransaction>} */
    jspb.Message.getRepeatedWrapperField(this, proto.bcsdk.MarkedTransaction, 8)
  );
};
/** @param {!Array<!proto.bcsdk.MarkedTransaction>} value */


proto.bcsdk.BlockchainHeader.prototype.setMarkedTxsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 8, value);
};
/**
 * @param {!proto.bcsdk.MarkedTransaction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.bcsdk.MarkedTransaction}
 */


proto.bcsdk.BlockchainHeader.prototype.addMarkedTxs = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.bcsdk.MarkedTransaction, opt_index);
};

proto.bcsdk.BlockchainHeader.prototype.clearMarkedTxsList = function () {
  this.setMarkedTxsList([]);
};

goog.object.extend(exports, proto.bcsdk);